import "./index.css";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/base64-js/index.js
var require_base64_js = __commonJS({
  "../../node_modules/base64-js/index.js"(exports) {
    "use strict";
    exports.byteLength = byteLength;
    exports.toByteArray = toByteArray;
    exports.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }
    var i;
    var len;
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
      var len2 = b64.length;
      if (len2 % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var validLen = b64.indexOf("=");
      if (validLen === -1)
        validLen = len2;
      var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }
    function byteLength(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;
      var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i2;
      for (i2 = 0; i2 < len2; i2 += 4) {
        tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
        arr[curByte++] = tmp >> 16 & 255;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start, end) {
      var tmp;
      var output = [];
      for (var i2 = start; i2 < end; i2 += 3) {
        tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
        output.push(tripletToBase64(tmp));
      }
      return output.join("");
    }
    function fromByteArray(uint8) {
      var tmp;
      var len2 = uint8.length;
      var extraBytes = len2 % 3;
      var parts = [];
      var maxChunkLength = 16383;
      for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
        parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
      }
      if (extraBytes === 1) {
        tmp = uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
        );
      } else if (extraBytes === 2) {
        tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
        );
      }
      return parts.join("");
    }
  }
});

// ../../node_modules/buffer/node_modules/ieee754/index.js
var require_ieee754 = __commonJS({
  "../../node_modules/buffer/node_modules/ieee754/index.js"(exports) {
    exports.read = function(buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];
      i += d;
      e = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      value = Math.abs(value);
      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }
        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
      }
      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
      }
      buffer[offset + i - d] |= s * 128;
    };
  }
});

// ../../node_modules/buffer/index.js
var require_buffer = __commonJS({
  "../../node_modules/buffer/index.js"(exports) {
    "use strict";
    var base64 = require_base64_js();
    var ieee754 = require_ieee754();
    var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
    exports.Buffer = Buffer3;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 2147483647;
    exports.kMaxLength = K_MAX_LENGTH;
    Buffer3.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer3.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
      console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
    }
    function typedArraySupport() {
      try {
        const arr = new Uint8Array(1);
        const proto = { foo: function() {
          return 42;
        } };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
      } catch (e) {
        return false;
      }
    }
    Object.defineProperty(Buffer3.prototype, "parent", {
      enumerable: true,
      get: function() {
        if (!Buffer3.isBuffer(this))
          return void 0;
        return this.buffer;
      }
    });
    Object.defineProperty(Buffer3.prototype, "offset", {
      enumerable: true,
      get: function() {
        if (!Buffer3.isBuffer(this))
          return void 0;
        return this.byteOffset;
      }
    });
    function createBuffer(length) {
      if (length > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length + '" is invalid for option "size"');
      }
      const buf = new Uint8Array(length);
      Object.setPrototypeOf(buf, Buffer3.prototype);
      return buf;
    }
    function Buffer3(arg, encodingOrOffset, length) {
      if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        }
        return allocUnsafe(arg);
      }
      return from(arg, encodingOrOffset, length);
    }
    Buffer3.poolSize = 8192;
    function from(value, encodingOrOffset, length) {
      if (typeof value === "string") {
        return fromString(value, encodingOrOffset);
      }
      if (ArrayBuffer.isView(value)) {
        return fromArrayView(value);
      }
      if (value == null) {
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
        );
      }
      if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof value === "number") {
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      }
      const valueOf = value.valueOf && value.valueOf();
      if (valueOf != null && valueOf !== value) {
        return Buffer3.from(valueOf, encodingOrOffset, length);
      }
      const b = fromObject(value);
      if (b)
        return b;
      if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
        return Buffer3.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
      }
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
      );
    }
    Buffer3.from = function(value, encodingOrOffset, length) {
      return from(value, encodingOrOffset, length);
    };
    Object.setPrototypeOf(Buffer3.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer3, Uint8Array);
    function assertSize(size) {
      if (typeof size !== "number") {
        throw new TypeError('"size" argument must be of type number');
      } else if (size < 0) {
        throw new RangeError('The value "' + size + '" is invalid for option "size"');
      }
    }
    function alloc(size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(size);
      }
      if (fill !== void 0) {
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
      }
      return createBuffer(size);
    }
    Buffer3.alloc = function(size, fill, encoding) {
      return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
      assertSize(size);
      return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    Buffer3.allocUnsafe = function(size) {
      return allocUnsafe(size);
    };
    Buffer3.allocUnsafeSlow = function(size) {
      return allocUnsafe(size);
    };
    function fromString(string, encoding) {
      if (typeof encoding !== "string" || encoding === "") {
        encoding = "utf8";
      }
      if (!Buffer3.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      const length = byteLength(string, encoding) | 0;
      let buf = createBuffer(length);
      const actual = buf.write(string, encoding);
      if (actual !== length) {
        buf = buf.slice(0, actual);
      }
      return buf;
    }
    function fromArrayLike(array) {
      const length = array.length < 0 ? 0 : checked(array.length) | 0;
      const buf = createBuffer(length);
      for (let i = 0; i < length; i += 1) {
        buf[i] = array[i] & 255;
      }
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
      }
      return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
      }
      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
      }
      let buf;
      if (byteOffset === void 0 && length === void 0) {
        buf = new Uint8Array(array);
      } else if (length === void 0) {
        buf = new Uint8Array(array, byteOffset);
      } else {
        buf = new Uint8Array(array, byteOffset, length);
      }
      Object.setPrototypeOf(buf, Buffer3.prototype);
      return buf;
    }
    function fromObject(obj) {
      if (Buffer3.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) {
          return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
      }
      if (obj.length !== void 0) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
          return createBuffer(0);
        }
        return fromArrayLike(obj);
      }
      if (obj.type === "Buffer" && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data);
      }
    }
    function checked(length) {
      if (length >= K_MAX_LENGTH) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
      }
      return length | 0;
    }
    function SlowBuffer(length) {
      if (+length != length) {
        length = 0;
      }
      return Buffer3.alloc(+length);
    }
    Buffer3.isBuffer = function isBuffer(b) {
      return b != null && b._isBuffer === true && b !== Buffer3.prototype;
    };
    Buffer3.compare = function compare(a, b) {
      if (isInstance(a, Uint8Array))
        a = Buffer3.from(a, a.offset, a.byteLength);
      if (isInstance(b, Uint8Array))
        b = Buffer3.from(b, b.offset, b.byteLength);
      if (!Buffer3.isBuffer(a) || !Buffer3.isBuffer(b)) {
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      }
      if (a === b)
        return 0;
      let x = a.length;
      let y = b.length;
      for (let i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    Buffer3.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer3.concat = function concat(list, length) {
      if (!Array.isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list.length === 0) {
        return Buffer3.alloc(0);
      }
      let i;
      if (length === void 0) {
        length = 0;
        for (i = 0; i < list.length; ++i) {
          length += list[i].length;
        }
      }
      const buffer = Buffer3.allocUnsafe(length);
      let pos = 0;
      for (i = 0; i < list.length; ++i) {
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
          if (pos + buf.length > buffer.length) {
            if (!Buffer3.isBuffer(buf))
              buf = Buffer3.from(buf);
            buf.copy(buffer, pos);
          } else {
            Uint8Array.prototype.set.call(
              buffer,
              buf,
              pos
            );
          }
        } else if (!Buffer3.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        } else {
          buf.copy(buffer, pos);
        }
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength(string, encoding) {
      if (Buffer3.isBuffer(string)) {
        return string.length;
      }
      if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
        return string.byteLength;
      }
      if (typeof string !== "string") {
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string
        );
      }
      const len = string.length;
      const mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len === 0)
        return 0;
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
            return utf8ToBytes(string).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string).length;
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string).length;
            }
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer3.byteLength = byteLength;
    function slowToString(encoding, start, end) {
      let loweredCase = false;
      if (start === void 0 || start < 0) {
        start = 0;
      }
      if (start > this.length) {
        return "";
      }
      if (end === void 0 || end > this.length) {
        end = this.length;
      }
      if (end <= 0) {
        return "";
      }
      end >>>= 0;
      start >>>= 0;
      if (end <= start) {
        return "";
      }
      if (!encoding)
        encoding = "utf8";
      while (true) {
        switch (encoding) {
          case "hex":
            return hexSlice(this, start, end);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start, end);
          case "ascii":
            return asciiSlice(this, start, end);
          case "latin1":
          case "binary":
            return latin1Slice(this, start, end);
          case "base64":
            return base64Slice(this, start, end);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start, end);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer3.prototype._isBuffer = true;
    function swap(b, n, m) {
      const i = b[n];
      b[n] = b[m];
      b[m] = i;
    }
    Buffer3.prototype.swap16 = function swap16() {
      const len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (let i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this;
    };
    Buffer3.prototype.swap32 = function swap32() {
      const len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (let i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer3.prototype.swap64 = function swap64() {
      const len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (let i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer3.prototype.toString = function toString() {
      const length = this.length;
      if (length === 0)
        return "";
      if (arguments.length === 0)
        return utf8Slice(this, 0, length);
      return slowToString.apply(this, arguments);
    };
    Buffer3.prototype.toLocaleString = Buffer3.prototype.toString;
    Buffer3.prototype.equals = function equals(b) {
      if (!Buffer3.isBuffer(b))
        throw new TypeError("Argument must be a Buffer");
      if (this === b)
        return true;
      return Buffer3.compare(this, b) === 0;
    };
    Buffer3.prototype.inspect = function inspect() {
      let str = "";
      const max = exports.INSPECT_MAX_BYTES;
      str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
      if (this.length > max)
        str += " ... ";
      return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) {
      Buffer3.prototype[customInspectSymbol] = Buffer3.prototype.inspect;
    }
    Buffer3.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (isInstance(target, Uint8Array)) {
        target = Buffer3.from(target, target.offset, target.byteLength);
      }
      if (!Buffer3.isBuffer(target)) {
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
        );
      }
      if (start === void 0) {
        start = 0;
      }
      if (end === void 0) {
        end = target ? target.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start >= end) {
        return 1;
      }
      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target)
        return 0;
      let x = thisEnd - thisStart;
      let y = end - start;
      const len = Math.min(x, y);
      const thisCopy = this.slice(thisStart, thisEnd);
      const targetCopy = target.slice(start, end);
      for (let i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
      if (buffer.length === 0)
        return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
      }
      if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir)
          return -1;
        else
          byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir)
          byteOffset = 0;
        else
          return -1;
      }
      if (typeof val === "string") {
        val = Buffer3.from(val, encoding);
      }
      if (Buffer3.isBuffer(val)) {
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
      } else if (typeof val === "number") {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      let indexSize = 1;
      let arrLength = arr.length;
      let valLength = val.length;
      if (encoding !== void 0) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i2) {
        if (indexSize === 1) {
          return buf[i2];
        } else {
          return buf.readUInt16BE(i2 * indexSize);
        }
      }
      let i;
      if (dir) {
        let foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1)
              foundIndex = i;
            if (i - foundIndex + 1 === valLength)
              return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1)
              i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength)
          byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }
          if (found)
            return i;
        }
      }
      return -1;
    }
    Buffer3.prototype.includes = function includes(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer3.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer3.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
      offset = Number(offset) || 0;
      const remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }
      const strLen = string.length;
      if (length > strLen / 2) {
        length = strLen / 2;
      }
      let i;
      for (i = 0; i < length; ++i) {
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed))
          return i;
        buf[offset + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string, offset, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
      return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
      return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer3.prototype.write = function write(string, offset, length, encoding) {
      if (offset === void 0) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
      } else if (length === void 0 && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
      } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
          length = length >>> 0;
          if (encoding === void 0)
            encoding = "utf8";
        } else {
          encoding = length;
          length = void 0;
        }
      } else {
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      }
      const remaining = this.length - offset;
      if (length === void 0 || length > remaining)
        length = remaining;
      if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding)
        encoding = "utf8";
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "hex":
            return hexWrite(this, string, offset, length);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string, offset, length);
          case "ascii":
          case "latin1":
          case "binary":
            return asciiWrite(this, string, offset, length);
          case "base64":
            return base64Write(this, string, offset, length);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string, offset, length);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer3.prototype.toJSON = function toJSON() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      const res = [];
      let i = start;
      while (i < end) {
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    var MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      const len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      let res = "";
      let i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res;
    }
    function asciiSlice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start, end) {
      const len = buf.length;
      if (!start || start < 0)
        start = 0;
      if (!end || end < 0 || end > len)
        end = len;
      let out = "";
      for (let i = start; i < end; ++i) {
        out += hexSliceLookupTable[buf[i]];
      }
      return out;
    }
    function utf16leSlice(buf, start, end) {
      const bytes = buf.slice(start, end);
      let res = "";
      for (let i = 0; i < bytes.length - 1; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer3.prototype.slice = function slice(start, end) {
      const len = this.length;
      start = ~~start;
      end = end === void 0 ? len : ~~end;
      if (start < 0) {
        start += len;
        if (start < 0)
          start = 0;
      } else if (start > len) {
        start = len;
      }
      if (end < 0) {
        end += len;
        if (end < 0)
          end = 0;
      } else if (end > len) {
        end = len;
      }
      if (end < start)
        end = start;
      const newBuf = this.subarray(start, end);
      Object.setPrototypeOf(newBuf, Buffer3.prototype);
      return newBuf;
    };
    function checkOffset(offset, ext, length) {
      if (offset % 1 !== 0 || offset < 0)
        throw new RangeError("offset is not uint");
      if (offset + ext > length)
        throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer3.prototype.readUintLE = Buffer3.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      return val;
    };
    Buffer3.prototype.readUintBE = Buffer3.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        checkOffset(offset, byteLength2, this.length);
      }
      let val = this[offset + --byteLength2];
      let mul = 1;
      while (byteLength2 > 0 && (mul *= 256)) {
        val += this[offset + --byteLength2] * mul;
      }
      return val;
    };
    Buffer3.prototype.readUint8 = Buffer3.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      return this[offset];
    };
    Buffer3.prototype.readUint16LE = Buffer3.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };
    Buffer3.prototype.readUint16BE = Buffer3.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };
    Buffer3.prototype.readUint32LE = Buffer3.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
    };
    Buffer3.prototype.readUint32BE = Buffer3.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer3.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
      const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer3.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer3.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer3.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let i = byteLength2;
      let mul = 1;
      let val = this[offset + --i];
      while (i > 0 && (mul *= 256)) {
        val += this[offset + --i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer3.prototype.readInt8 = function readInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      if (!(this[offset] & 128))
        return this[offset];
      return (255 - this[offset] + 1) * -1;
    };
    Buffer3.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset] | this[offset + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer3.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset + 1] | this[offset] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer3.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer3.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer3.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer3.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = (first << 24) + // Overflow
      this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
    });
    Buffer3.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, true, 23, 4);
    };
    Buffer3.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, false, 23, 4);
    };
    Buffer3.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, true, 52, 8);
    };
    Buffer3.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
      if (!Buffer3.isBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
    }
    Buffer3.prototype.writeUintLE = Buffer3.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let mul = 1;
      let i = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer3.prototype.writeUintBE = Buffer3.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer3.prototype.writeUint8 = Buffer3.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 255, 0);
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer3.prototype.writeUint16LE = Buffer3.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer3.prototype.writeUint16BE = Buffer3.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer3.prototype.writeUint32LE = Buffer3.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset + 3] = value >>> 24;
      this[offset + 2] = value >>> 16;
      this[offset + 1] = value >>> 8;
      this[offset] = value & 255;
      return offset + 4;
    };
    Buffer3.prototype.writeUint32BE = Buffer3.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
      checkIntBI(value, min, max, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
      checkIntBI(value, min, max, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset + 7] = lo;
      lo = lo >> 8;
      buf[offset + 6] = lo;
      lo = lo >> 8;
      buf[offset + 5] = lo;
      lo = lo >> 8;
      buf[offset + 4] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset + 3] = hi;
      hi = hi >> 8;
      buf[offset + 2] = hi;
      hi = hi >> 8;
      buf[offset + 1] = hi;
      hi = hi >> 8;
      buf[offset] = hi;
      return offset + 8;
    }
    Buffer3.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer3.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer3.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = 0;
      let mul = 1;
      let sub = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer3.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      let sub = 0;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer3.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 127, -128);
      if (value < 0)
        value = 255 + value + 1;
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer3.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer3.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer3.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      this[offset + 2] = value >>> 16;
      this[offset + 3] = value >>> 24;
      return offset + 4;
    };
    Buffer3.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      if (value < 0)
        value = 4294967295 + value + 1;
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    Buffer3.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer3.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
      if (offset < 0)
        throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
      }
      ieee754.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }
    Buffer3.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer3.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
      }
      ieee754.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }
    Buffer3.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer3.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    };
    Buffer3.prototype.copy = function copy(target, targetStart, start, end) {
      if (!Buffer3.isBuffer(target))
        throw new TypeError("argument should be a Buffer");
      if (!start)
        start = 0;
      if (!end && end !== 0)
        end = this.length;
      if (targetStart >= target.length)
        targetStart = target.length;
      if (!targetStart)
        targetStart = 0;
      if (end > 0 && end < start)
        end = start;
      if (end === start)
        return 0;
      if (target.length === 0 || this.length === 0)
        return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start < 0 || start >= this.length)
        throw new RangeError("Index out of range");
      if (end < 0)
        throw new RangeError("sourceEnd out of bounds");
      if (end > this.length)
        end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      const len = end - start;
      if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
        this.copyWithin(targetStart, start, end);
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, end),
          targetStart
        );
      }
      return len;
    };
    Buffer3.prototype.fill = function fill(val, start, end, encoding) {
      if (typeof val === "string") {
        if (typeof start === "string") {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === "string") {
          encoding = end;
          end = this.length;
        }
        if (encoding !== void 0 && typeof encoding !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding === "string" && !Buffer3.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        if (val.length === 1) {
          const code = val.charCodeAt(0);
          if (encoding === "utf8" && code < 128 || encoding === "latin1") {
            val = code;
          }
        }
      } else if (typeof val === "number") {
        val = val & 255;
      } else if (typeof val === "boolean") {
        val = Number(val);
      }
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError("Out of range index");
      }
      if (end <= start) {
        return this;
      }
      start = start >>> 0;
      end = end === void 0 ? this.length : end >>> 0;
      if (!val)
        val = 0;
      let i;
      if (typeof val === "number") {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        const bytes = Buffer3.isBuffer(val) ? val : Buffer3.from(val, encoding);
        const len = bytes.length;
        if (len === 0) {
          throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }
      return this;
    };
    var errors = {};
    function E(sym, getMessage, Base) {
      errors[sym] = class NodeError extends Base {
        constructor() {
          super();
          Object.defineProperty(this, "message", {
            value: getMessage.apply(this, arguments),
            writable: true,
            configurable: true
          });
          this.name = `${this.name} [${sym}]`;
          this.stack;
          delete this.name;
        }
        get code() {
          return sym;
        }
        set code(value) {
          Object.defineProperty(this, "code", {
            configurable: true,
            enumerable: true,
            value,
            writable: true
          });
        }
        toString() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      };
    }
    E(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(name) {
        if (name) {
          return `${name} is outside of buffer bounds`;
        }
        return "Attempt to access memory outside buffer bounds";
      },
      RangeError
    );
    E(
      "ERR_INVALID_ARG_TYPE",
      function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
      },
      TypeError
    );
    E(
      "ERR_OUT_OF_RANGE",
      function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
          received = addNumericalSeparator(String(input));
        } else if (typeof input === "bigint") {
          received = String(input);
          if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
            received = addNumericalSeparator(received);
          }
          received += "n";
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
      },
      RangeError
    );
    function addNumericalSeparator(val) {
      let res = "";
      let i = val.length;
      const start = val[0] === "-" ? 1 : 0;
      for (; i >= start + 4; i -= 3) {
        res = `_${val.slice(i - 3, i)}${res}`;
      }
      return `${val.slice(0, i)}${res}`;
    }
    function checkBounds(buf, offset, byteLength2) {
      validateNumber(offset, "offset");
      if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
        boundsError(offset, buf.length - (byteLength2 + 1));
      }
    }
    function checkIntBI(value, min, max, buf, offset, byteLength2) {
      if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength2 > 3) {
          if (min === 0 || min === BigInt(0)) {
            range = `>= 0${n} and < 2${n} ** ${(byteLength2 + 1) * 8}${n}`;
          } else {
            range = `>= -(2${n} ** ${(byteLength2 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n}`;
          }
        } else {
          range = `>= ${min}${n} and <= ${max}${n}`;
        }
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
      }
      checkBounds(buf, offset, byteLength2);
    }
    function validateNumber(value, name) {
      if (typeof value !== "number") {
        throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
      }
    }
    function boundsError(value, length, type) {
      if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
      }
      if (length < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
      }
      throw new errors.ERR_OUT_OF_RANGE(
        type || "offset",
        `>= ${type ? 1 : 0} and <= ${length}`,
        value
      );
    }
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = str.split("=")[0];
      str = str.trim().replace(INVALID_BASE64_RE, "");
      if (str.length < 2)
        return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function utf8ToBytes(string, units) {
      units = units || Infinity;
      let codePoint;
      const length = string.length;
      let leadSurrogate = null;
      const bytes = [];
      for (let i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            } else if (i + 1 === length) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units -= 1) < 0)
            break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0)
            break;
          bytes.push(
            codePoint >> 6 | 192,
            codePoint & 63 | 128
          );
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0)
            break;
          bytes.push(
            codePoint >> 12 | 224,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0)
            break;
          bytes.push(
            codePoint >> 18 | 240,
            codePoint >> 12 & 63 | 128,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      let c, hi, lo;
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0)
          break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
      let i;
      for (i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length)
          break;
        dst[i + offset] = src[i];
      }
      return i;
    }
    function isInstance(obj, type) {
      return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
      return obj !== obj;
    }
    var hexSliceLookupTable = function() {
      const alphabet = "0123456789abcdef";
      const table = new Array(256);
      for (let i = 0; i < 16; ++i) {
        const i16 = i * 16;
        for (let j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j];
        }
      }
      return table;
    }();
    function defineBigIntMethod(fn) {
      return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
      throw new Error("BigInt not supported");
    }
  }
});

// ../../node_modules/papaparse/papaparse.min.js
var require_papaparse_min = __commonJS({
  "../../node_modules/papaparse/papaparse.min.js"(exports, module) {
    ((e, t) => {
      "function" == typeof define && define.amd ? define([], t) : "object" == typeof module && "undefined" != typeof exports ? module.exports = t() : e.Papa = t();
    })(exports, function r() {
      var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
      var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || false, o = {}, h = 0, v = {};
      function u(e) {
        this._handle = null, this._finished = false, this._completed = false, this._halted = false, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = true, this._completeResults = { data: [], errors: [], meta: {} }, function(e2) {
          var t = b(e2);
          t.chunkSize = parseInt(t.chunkSize), e2.step || e2.chunk || (t.chunkSize = null);
          this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }.call(this, e), this.parseChunk = function(t, e2) {
          var i2 = parseInt(this._config.skipFirstNLines) || 0;
          if (this.isFirstChunk && 0 < i2) {
            let e3 = this._config.newline;
            e3 || (r2 = this._config.quoteChar || '"', e3 = this._handle.guessLineEndings(t, r2)), t = [...t.split(e3).slice(i2)].join(e3);
          }
          this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r2 = this._config.beforeFirstChunk(t)) && (t = r2), this.isFirstChunk = false, this._halted = false;
          var i2 = this._partialLine + t, r2 = (this._partialLine = "", this._handle.parse(i2, this._baseIndex, !this._finished));
          if (!this._handle.paused() && !this._handle.aborted()) {
            t = r2.meta.cursor, i2 = (this._finished || (this._partialLine = i2.substring(t - this._baseIndex), this._baseIndex = t), r2 && r2.data && (this._rowCount += r2.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
            if (a)
              n.postMessage({ results: r2, workerId: v.WORKER_ID, finished: i2 });
            else if (U(this._config.chunk) && !e2) {
              if (this._config.chunk(r2, this._handle), this._handle.paused() || this._handle.aborted())
                return void (this._halted = true);
              this._completeResults = r2 = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r2.data), this._completeResults.errors = this._completeResults.errors.concat(r2.errors), this._completeResults.meta = r2.meta), this._completed || !i2 || !U(this._config.complete) || r2 && r2.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = true), i2 || r2 && r2.meta.paused || this._nextChunk(), r2;
          }
          this._halted = true;
        }, this._sendError = function(e2) {
          U(this._config.error) ? this._config.error(e2) : a && this._config.error && n.postMessage({ workerId: v.WORKER_ID, error: e2, finished: false });
        };
      }
      function f(e) {
        var r2;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(e2) {
          this._input = e2, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished)
            this._chunkLoaded();
          else {
            if (r2 = new XMLHttpRequest(), this._config.withCredentials && (r2.withCredentials = this._config.withCredentials), s || (r2.onload = y(this._chunkLoaded, this), r2.onerror = y(this._chunkError, this)), r2.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
              var e2, t = this._config.downloadRequestHeaders;
              for (e2 in t)
                r2.setRequestHeader(e2, t[e2]);
            }
            var i2;
            this._config.chunkSize && (i2 = this._start + this._config.chunkSize - 1, r2.setRequestHeader("Range", "bytes=" + this._start + "-" + i2));
            try {
              r2.send(this._config.downloadRequestBody);
            } catch (e3) {
              this._chunkError(e3.message);
            }
            s && 0 === r2.status && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          4 === r2.readyState && (r2.status < 200 || 400 <= r2.status ? this._chunkError() : (this._start += this._config.chunkSize || r2.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e2) => null !== (e2 = e2.getResponseHeader("Content-Range")) ? parseInt(e2.substring(e2.lastIndexOf("/") + 1)) : -1)(r2), this.parseChunk(r2.responseText)));
        }, this._chunkError = function(e2) {
          e2 = r2.statusText || e2;
          this._sendError(new Error(e2));
        };
      }
      function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i2, r2, n2 = "undefined" != typeof FileReader;
        this.stream = function(e2) {
          this._input = e2, r2 = e2.slice || e2.webkitSlice || e2.mozSlice, n2 ? ((i2 = new FileReader()).onload = y(this._chunkLoaded, this), i2.onerror = y(this._chunkError, this)) : i2 = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var e2 = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e2 = r2.call(e2, this._start, t)), i2.readAsText(e2, this._config.encoding));
          n2 || this._chunkLoaded({ target: { result: t } });
        }, this._chunkLoaded = function(e2) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e2.target.result);
        }, this._chunkError = function() {
          this._sendError(i2.error);
        };
      }
      function c(e) {
        var i2;
        u.call(this, e = e || {}), this.stream = function(e2) {
          return i2 = e2, this._nextChunk();
        }, this._nextChunk = function() {
          var e2, t;
          if (!this._finished)
            return e2 = this._config.chunkSize, i2 = e2 ? (t = i2.substring(0, e2), i2.substring(e2)) : (t = i2, ""), this._finished = !i2, this.parseChunk(t);
        };
      }
      function p(e) {
        u.call(this, e = e || {});
        var t = [], i2 = true, r2 = false;
        this.pause = function() {
          u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e2) {
          this._input = e2, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          r2 && 1 === t.length && (this._finished = true);
        }, this._nextChunk = function() {
          this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i2 = true;
        }, this._streamData = y(function(e2) {
          try {
            t.push("string" == typeof e2 ? e2 : e2.toString(this._config.encoding)), i2 && (i2 = false, this._checkIsFinished(), this.parseChunk(t.shift()));
          } catch (e3) {
            this._streamError(e3);
          }
        }, this), this._streamError = y(function(e2) {
          this._streamCleanUp(), this._sendError(e2);
        }, this), this._streamEnd = y(function() {
          this._streamCleanUp(), r2 = true, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function i(m2) {
        var n2, s2, a2, t, o2 = Math.pow(2, 53), h2 = -o2, u2 = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d2 = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i2 = this, r2 = 0, f2 = 0, l2 = false, e = false, c2 = [], p2 = { data: [], errors: [], meta: {} };
        function y2(e2) {
          return "greedy" === m2.skipEmptyLines ? "" === e2.join("").trim() : 1 === e2.length && 0 === e2[0].length;
        }
        function g2() {
          if (p2 && a2 && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a2 = false), m2.skipEmptyLines && (p2.data = p2.data.filter(function(e3) {
            return !y2(e3);
          })), _2()) {
            let t3 = function(e3, t4) {
              U(m2.transformHeader) && (e3 = m2.transformHeader(e3, t4)), c2.push(e3);
            };
            var t2 = t3;
            if (p2)
              if (Array.isArray(p2.data[0])) {
                for (var e2 = 0; _2() && e2 < p2.data.length; e2++)
                  p2.data[e2].forEach(t3);
                p2.data.splice(0, 1);
              } else
                p2.data.forEach(t3);
          }
          function i3(e3, t3) {
            for (var i4 = m2.header ? {} : [], r4 = 0; r4 < e3.length; r4++) {
              var n3 = r4, s3 = e3[r4], s3 = ((e4, t4) => ((e5) => (m2.dynamicTypingFunction && void 0 === m2.dynamicTyping[e5] && (m2.dynamicTyping[e5] = m2.dynamicTypingFunction(e5)), true === (m2.dynamicTyping[e5] || m2.dynamicTyping)))(e4) ? "true" === t4 || "TRUE" === t4 || "false" !== t4 && "FALSE" !== t4 && (((e5) => {
                if (u2.test(e5)) {
                  e5 = parseFloat(e5);
                  if (h2 < e5 && e5 < o2)
                    return 1;
                }
              })(t4) ? parseFloat(t4) : d2.test(t4) ? new Date(t4) : "" === t4 ? null : t4) : t4)(n3 = m2.header ? r4 >= c2.length ? "__parsed_extra" : c2[r4] : n3, s3 = m2.transform ? m2.transform(s3, n3) : s3);
              "__parsed_extra" === n3 ? (i4[n3] = i4[n3] || [], i4[n3].push(s3)) : i4[n3] = s3;
            }
            return m2.header && (r4 > c2.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c2.length + " fields but parsed " + r4, f2 + t3) : r4 < c2.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c2.length + " fields but parsed " + r4, f2 + t3)), i4;
          }
          var r3;
          p2 && (m2.header || m2.dynamicTyping || m2.transform) && (r3 = 1, !p2.data.length || Array.isArray(p2.data[0]) ? (p2.data = p2.data.map(i3), r3 = p2.data.length) : p2.data = i3(p2.data, 0), m2.header && p2.meta && (p2.meta.fields = c2), f2 += r3);
        }
        function _2() {
          return m2.header && 0 === c2.length;
        }
        function k(e2, t2, i3, r3) {
          e2 = { type: e2, code: t2, message: i3 };
          void 0 !== r3 && (e2.row = r3), p2.errors.push(e2);
        }
        U(m2.step) && (t = m2.step, m2.step = function(e2) {
          p2 = e2, _2() ? g2() : (g2(), 0 !== p2.data.length && (r2 += e2.data.length, m2.preview && r2 > m2.preview ? s2.abort() : (p2.data = p2.data[0], t(p2, i2))));
        }), this.parse = function(e2, t2, i3) {
          var r3 = m2.quoteChar || '"', r3 = (m2.newline || (m2.newline = this.guessLineEndings(e2, r3)), a2 = false, m2.delimiter ? U(m2.delimiter) && (m2.delimiter = m2.delimiter(e2), p2.meta.delimiter = m2.delimiter) : ((r3 = ((e3, t3, i4, r4, n3) => {
            var s3, a3, o3, h3;
            n3 = n3 || [",", "	", "|", ";", v.RECORD_SEP, v.UNIT_SEP];
            for (var u3 = 0; u3 < n3.length; u3++) {
              for (var d3, f3 = n3[u3], l3 = 0, c3 = 0, p3 = 0, g3 = (o3 = void 0, new E({ comments: r4, delimiter: f3, newline: t3, preview: 10 }).parse(e3)), _3 = 0; _3 < g3.data.length; _3++)
                i4 && y2(g3.data[_3]) ? p3++ : (d3 = g3.data[_3].length, c3 += d3, void 0 === o3 ? o3 = d3 : 0 < d3 && (l3 += Math.abs(d3 - o3), o3 = d3));
              0 < g3.data.length && (c3 /= g3.data.length - p3), (void 0 === a3 || l3 <= a3) && (void 0 === h3 || h3 < c3) && 1.99 < c3 && (a3 = l3, s3 = f3, h3 = c3);
            }
            return { successful: !!(m2.delimiter = s3), bestDelimiter: s3 };
          })(e2, m2.newline, m2.skipEmptyLines, m2.comments, m2.delimitersToGuess)).successful ? m2.delimiter = r3.bestDelimiter : (a2 = true, m2.delimiter = v.DefaultDelimiter), p2.meta.delimiter = m2.delimiter), b(m2));
          return m2.preview && m2.header && r3.preview++, n2 = e2, s2 = new E(r3), p2 = s2.parse(n2, t2, i3), g2(), l2 ? { meta: { paused: true } } : p2 || { meta: { paused: false } };
        }, this.paused = function() {
          return l2;
        }, this.pause = function() {
          l2 = true, s2.abort(), n2 = U(m2.chunk) ? "" : n2.substring(s2.getCharIndex());
        }, this.resume = function() {
          i2.streamer._halted ? (l2 = false, i2.streamer.parseChunk(n2, true)) : setTimeout(i2.resume, 3);
        }, this.aborted = function() {
          return e;
        }, this.abort = function() {
          e = true, s2.abort(), p2.meta.aborted = true, U(m2.complete) && m2.complete(p2), n2 = "";
        }, this.guessLineEndings = function(e2, t2) {
          e2 = e2.substring(0, 1048576);
          var t2 = new RegExp(P(t2) + "([^]*?)" + P(t2), "gm"), i3 = (e2 = e2.replace(t2, "")).split("\r"), t2 = e2.split("\n"), e2 = 1 < t2.length && t2[0].length < i3[0].length;
          if (1 === i3.length || e2)
            return "\n";
          for (var r3 = 0, n3 = 0; n3 < i3.length; n3++)
            "\n" === i3[n3][0] && r3++;
          return r3 >= i3.length / 2 ? "\r\n" : "\r";
        };
      }
      function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = false, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S)
          throw new Error("Comment character same as delimiter");
        true === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = false), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = false;
        this.parse = function(i2, t, r2) {
          if ("string" != typeof i2)
            throw new Error("Input must be a string");
          var n2 = i2.length, e = S.length, s2 = O.length, a2 = x.length, o2 = U(I), h2 = [], u2 = [], d2 = [], f2 = z = 0;
          if (!i2)
            return w();
          if (T || false !== T && -1 === i2.indexOf(F)) {
            for (var l2 = i2.split(O), c2 = 0; c2 < l2.length; c2++) {
              if (d2 = l2[c2], z += d2.length, c2 !== l2.length - 1)
                z += O.length;
              else if (r2)
                return w();
              if (!x || d2.substring(0, a2) !== x) {
                if (o2) {
                  if (h2 = [], k(d2.split(S)), R(), M)
                    return w();
                } else
                  k(d2.split(S));
                if (A && A <= c2)
                  return h2 = h2.slice(0, A), w(true);
              }
            }
            return w();
          }
          for (var p2 = i2.indexOf(S, z), g2 = i2.indexOf(O, z), _2 = new RegExp(P(j) + P(F), "g"), m2 = i2.indexOf(F, z); ; )
            if (i2[z] === F)
              for (m2 = z, z++; ; ) {
                if (-1 === (m2 = i2.indexOf(F, m2 + 1)))
                  return r2 || u2.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: h2.length, index: z }), E2();
                if (m2 === n2 - 1)
                  return E2(i2.substring(z, m2).replace(_2, F));
                if (F === j && i2[m2 + 1] === j)
                  m2++;
                else if (F === j || 0 === m2 || i2[m2 - 1] !== j) {
                  -1 !== p2 && p2 < m2 + 1 && (p2 = i2.indexOf(S, m2 + 1));
                  var y2 = v2(-1 === (g2 = -1 !== g2 && g2 < m2 + 1 ? i2.indexOf(O, m2 + 1) : g2) ? p2 : Math.min(p2, g2));
                  if (i2.substr(m2 + 1 + y2, e) === S) {
                    d2.push(i2.substring(z, m2).replace(_2, F)), i2[z = m2 + 1 + y2 + e] !== F && (m2 = i2.indexOf(F, z)), p2 = i2.indexOf(S, z), g2 = i2.indexOf(O, z);
                    break;
                  }
                  y2 = v2(g2);
                  if (i2.substring(m2 + 1 + y2, m2 + 1 + y2 + s2) === O) {
                    if (d2.push(i2.substring(z, m2).replace(_2, F)), b2(m2 + 1 + y2 + s2), p2 = i2.indexOf(S, z), m2 = i2.indexOf(F, z), o2 && (R(), M))
                      return w();
                    if (A && h2.length >= A)
                      return w(true);
                    break;
                  }
                  u2.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: h2.length, index: z }), m2++;
                }
              }
            else if (x && 0 === d2.length && i2.substring(z, z + a2) === x) {
              if (-1 === g2)
                return w();
              z = g2 + s2, g2 = i2.indexOf(O, z), p2 = i2.indexOf(S, z);
            } else if (-1 !== p2 && (p2 < g2 || -1 === g2))
              d2.push(i2.substring(z, p2)), z = p2 + e, p2 = i2.indexOf(S, z);
            else {
              if (-1 === g2)
                break;
              if (d2.push(i2.substring(z, g2)), b2(g2 + s2), o2 && (R(), M))
                return w();
              if (A && h2.length >= A)
                return w(true);
            }
          return E2();
          function k(e2) {
            h2.push(e2), f2 = z;
          }
          function v2(e2) {
            var t2 = 0;
            return t2 = -1 !== e2 && (e2 = i2.substring(m2 + 1, e2)) && "" === e2.trim() ? e2.length : t2;
          }
          function E2(e2) {
            return r2 || (void 0 === e2 && (e2 = i2.substring(z)), d2.push(e2), z = n2, k(d2), o2 && R()), w();
          }
          function b2(e2) {
            z = e2, k(d2), d2 = [], g2 = i2.indexOf(O, z);
          }
          function w(e2) {
            if (C.header && !t && h2.length && !L) {
              var s3 = h2[0], a3 = /* @__PURE__ */ Object.create(null), o3 = new Set(s3);
              let n3 = false;
              for (let r3 = 0; r3 < s3.length; r3++) {
                let i3 = s3[r3];
                if (a3[i3 = U(C.transformHeader) ? C.transformHeader(i3, r3) : i3]) {
                  let e3, t2 = a3[i3];
                  for (; e3 = i3 + "_" + t2, t2++, o3.has(e3); )
                    ;
                  o3.add(e3), s3[r3] = e3, a3[i3]++, n3 = true, (D = null === D ? {} : D)[e3] = i3;
                } else
                  a3[i3] = 1, s3[r3] = i3;
                o3.add(i3);
              }
              n3 && console.warn("Duplicate headers found and renamed."), L = true;
            }
            return { data: h2, errors: u2, meta: { delimiter: S, linebreak: O, aborted: M, truncated: !!e2, cursor: f2 + (t || 0), renamedHeaders: D } };
          }
          function R() {
            I(w()), h2 = [], u2 = [];
          }
        }, this.abort = function() {
          M = true;
        }, this.getCharIndex = function() {
          return z;
        };
      }
      function g(e) {
        var t = e.data, i2 = o[t.workerId], r2 = false;
        if (t.error)
          i2.userError(t.error, t.file);
        else if (t.results && t.results.data) {
          var n2 = { abort: function() {
            r2 = true, _(t.workerId, { data: [], errors: [], meta: { aborted: true } });
          }, pause: m, resume: m };
          if (U(i2.userStep)) {
            for (var s2 = 0; s2 < t.results.data.length && (i2.userStep({ data: t.results.data[s2], errors: t.results.errors, meta: t.results.meta }, n2), !r2); s2++)
              ;
            delete t.results;
          } else
            U(i2.userChunk) && (i2.userChunk(t.results, n2, t.file), delete t.results);
        }
        t.finished && !r2 && _(t.workerId, t.results);
      }
      function _(e, t) {
        var i2 = o[e];
        U(i2.userComplete) && i2.userComplete(t), i2.terminate(), delete o[e];
      }
      function m() {
        throw new Error("Not implemented.");
      }
      function b(e) {
        if ("object" != typeof e || null === e)
          return e;
        var t, i2 = Array.isArray(e) ? [] : {};
        for (t in e)
          i2[t] = b(e[t]);
        return i2;
      }
      function y(e, t) {
        return function() {
          e.apply(t, arguments);
        };
      }
      function U(e) {
        return "function" == typeof e;
      }
      return v.parse = function(e, t) {
        var i2 = (t = t || {}).dynamicTyping || false;
        U(i2) && (t.dynamicTypingFunction = i2, i2 = {});
        if (t.dynamicTyping = i2, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED)
          return i2 = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e2) => 65279 !== e2.charCodeAt(0) ? e2 : e2.slice(1))(e), i2 = new (t.download ? f : c)(t)) : true === e.readable && U(e.read) && U(e.on) ? i2 = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i2 = new l(t)), i2.stream(e);
        (i2 = (() => {
          var e2;
          return !!v.WORKERS_SUPPORTED && (e2 = (() => {
            var e3 = n.URL || n.webkitURL || null, t2 = r.toString();
            return v.BLOB_URL || (v.BLOB_URL = e3.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", t2, ")();"], { type: "text/javascript" })));
          })(), (e2 = new n.Worker(e2)).onmessage = g, e2.id = h++, o[e2.id] = e2);
        })()).userStep = t.step, i2.userChunk = t.chunk, i2.userComplete = t.complete, i2.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i2.postMessage({ input: e, config: t, workerId: i2.id });
      }, v.unparse = function(e, t) {
        var n2 = false, _2 = true, m2 = ",", y2 = "\r\n", s2 = '"', a2 = s2 + s2, i2 = false, r2 = null, o2 = false, h2 = ((() => {
          if ("object" == typeof t) {
            if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e2) {
              return -1 !== t.delimiter.indexOf(e2);
            }).length || (m2 = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n2 = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i2 = t.skipEmptyLines), "string" == typeof t.newline && (y2 = t.newline), "string" == typeof t.quoteChar && (s2 = t.quoteChar), "boolean" == typeof t.header && (_2 = t.header), Array.isArray(t.columns)) {
              if (0 === t.columns.length)
                throw new Error("Option columns is empty");
              r2 = t.columns;
            }
            void 0 !== t.escapeChar && (a2 = t.escapeChar + s2), t.escapeFormulae instanceof RegExp ? o2 = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o2 = /^[=+\-@\t\r].*$/);
          }
        })(), new RegExp(P(s2), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
          if (!e.length || Array.isArray(e[0]))
            return u2(null, e, i2);
          if ("object" == typeof e[0])
            return u2(r2 || Object.keys(e[0]), e, i2);
        } else if ("object" == typeof e)
          return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r2), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [e.data])), u2(e.fields || [], e.data || [], i2);
        throw new Error("Unable to serialize unrecognized input");
        function u2(e2, t2, i3) {
          var r3 = "", n3 = ("string" == typeof e2 && (e2 = JSON.parse(e2)), "string" == typeof t2 && (t2 = JSON.parse(t2)), Array.isArray(e2) && 0 < e2.length), s3 = !Array.isArray(t2[0]);
          if (n3 && _2) {
            for (var a3 = 0; a3 < e2.length; a3++)
              0 < a3 && (r3 += m2), r3 += k(e2[a3], a3);
            0 < t2.length && (r3 += y2);
          }
          for (var o3 = 0; o3 < t2.length; o3++) {
            var h3 = (n3 ? e2 : t2[o3]).length, u3 = false, d2 = n3 ? 0 === Object.keys(t2[o3]).length : 0 === t2[o3].length;
            if (i3 && !n3 && (u3 = "greedy" === i3 ? "" === t2[o3].join("").trim() : 1 === t2[o3].length && 0 === t2[o3][0].length), "greedy" === i3 && n3) {
              for (var f2 = [], l2 = 0; l2 < h3; l2++) {
                var c2 = s3 ? e2[l2] : l2;
                f2.push(t2[o3][c2]);
              }
              u3 = "" === f2.join("").trim();
            }
            if (!u3) {
              for (var p2 = 0; p2 < h3; p2++) {
                0 < p2 && !d2 && (r3 += m2);
                var g2 = n3 && s3 ? e2[p2] : p2;
                r3 += k(t2[o3][g2], p2);
              }
              o3 < t2.length - 1 && (!i3 || 0 < h3 && !d2) && (r3 += y2);
            }
          }
          return r3;
        }
        function k(e2, t2) {
          var i3, r3;
          return null == e2 ? "" : e2.constructor === Date ? JSON.stringify(e2).slice(1, 25) : (r3 = false, o2 && "string" == typeof e2 && o2.test(e2) && (e2 = "'" + e2, r3 = true), i3 = e2.toString().replace(h2, a2), (r3 = r3 || true === n2 || "function" == typeof n2 && n2(e2, t2) || Array.isArray(n2) && n2[t2] || ((e3, t3) => {
            for (var i4 = 0; i4 < t3.length; i4++)
              if (-1 < e3.indexOf(t3[i4]))
                return true;
            return false;
          })(i3, v.BAD_DELIMITERS) || -1 < i3.indexOf(m2) || " " === i3.charAt(0) || " " === i3.charAt(i3.length - 1)) ? s2 + i3 + s2 : i3);
        }
      }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\uFEFF", v.BAD_DELIMITERS = ["\r", "\n", '"', v.BYTE_ORDER_MARK], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o2) {
        var i2 = o2.config || {}, h2 = [];
        return this.each(function(e2) {
          if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length)
            return true;
          for (var t = 0; t < this.files.length; t++)
            h2.push({ file: this.files[t], inputElem: this, instanceConfig: d.extend({}, i2) });
        }), e(), this;
        function e() {
          if (0 === h2.length)
            U(o2.complete) && o2.complete();
          else {
            var e2, t, i3, r2, n2 = h2[0];
            if (U(o2.before)) {
              var s2 = o2.before(n2.file, n2.inputElem);
              if ("object" == typeof s2) {
                if ("abort" === s2.action)
                  return e2 = "AbortError", t = n2.file, i3 = n2.inputElem, r2 = s2.reason, void (U(o2.error) && o2.error({ name: e2 }, t, i3, r2));
                if ("skip" === s2.action)
                  return void u2();
                "object" == typeof s2.config && (n2.instanceConfig = d.extend(n2.instanceConfig, s2.config));
              } else if ("skip" === s2)
                return void u2();
            }
            var a2 = n2.instanceConfig.complete;
            n2.instanceConfig.complete = function(e3) {
              U(a2) && a2(e3, n2.file, n2.inputElem), u2();
            }, v.parse(n2.file, n2.instanceConfig);
          }
        }
        function u2() {
          h2.splice(0, 1), e();
        }
      }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({ workerId: v.WORKER_ID, results: v.parse(e.input, e.config), finished: true }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({ workerId: v.WORKER_ID, results: e, finished: true });
      }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
    });
  }
});

// src/DocumentExporter/polyfills.ts
var import_buffer = __toESM(require_buffer(), 1);
function initializePDFPolyfills() {
  if (typeof window !== "undefined") {
    window.Buffer = import_buffer.Buffer;
  }
}

// src/DocumentExporter/ModeContext.tsx
import { createContext, useContext } from "react";
var ModeContext = createContext("ui");
var useExportMode = () => useContext(ModeContext);
var ModeProvider = ModeContext.Provider;

// src/DocumentExporter/document/Document.tsx
import { Document as PDFDocumentContainer } from "@react-pdf/renderer";

// src/DocumentExporter/fonts/font-config.ts
import { Font } from "@react-pdf/renderer";
var PDF_FONT_FAMILY = "Open Sans";
function registerPDFFonts() {
  Font.register({
    family: PDF_FONT_FAMILY,
    fonts: [
      {
        src: "https://fonts.gstatic.com/s/opensans/v44/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf",
        fontWeight: 300
      },
      {
        src: "https://fonts.gstatic.com/s/opensans/v44/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf",
        fontWeight: 400
      },
      {
        src: "https://fonts.gstatic.com/s/opensans/v44/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf",
        fontWeight: 600
      },
      {
        src: "https://fonts.gstatic.com/s/opensans/v44/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf",
        fontWeight: 700
      }
    ]
  });
}

// src/DocumentExporter/layout/Box.tsx
import { Text } from "@react-pdf/renderer";

// src/DocumentExporter/fonts/pdf-styles.ts
import { StyleSheet } from "@react-pdf/renderer";
var pdfStyles = StyleSheet.create({
  // Composable text size styles - weight applied separately in Text component
  textS: {
    fontFamily: PDF_FONT_FAMILY,
    fontSize: 5
  },
  textM: {
    fontFamily: PDF_FONT_FAMILY,
    fontSize: 9
  },
  textL: {
    fontFamily: PDF_FONT_FAMILY,
    fontSize: 12
  },
  // Legacy complete styles for components not yet using Text component
  text: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 400,
    fontSize: 12
  },
  textBold: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700,
    fontSize: 12
  },
  // Header styles
  h1: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700,
    fontSize: 24
  },
  h2: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700,
    fontSize: 20
  },
  h3: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700,
    fontSize: 16
  },
  // Link style
  link: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 400,
    fontSize: 12,
    color: "#0073bb",
    textDecoration: "underline"
  },
  // Buy button styles
  buyButton: {
    backgroundColor: "#EC7211",
    paddingVertical: 6,
    paddingHorizontal: 20,
    borderRadius: 16,
    alignSelf: "flex-start"
  },
  buyButtonCompact: {
    backgroundColor: "#EC7211",
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 12,
    alignSelf: "flex-start"
  },
  buyButtonText: {
    color: "#000000",
    fontSize: 11,
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700
  },
  buyButtonTextCompact: {
    color: "#000000",
    fontSize: 8,
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700
  }
});

// src/DocumentExporter/layout/Box.tsx
import CloudscapeBox from "@cloudscape-design/components/box";
import { jsx } from "react/jsx-runtime";
var Box = ({ children, variant, fontWeight, color }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const baseStyle = fontWeight === "bold" ? pdfStyles.textBold : pdfStyles.text;
    return /* @__PURE__ */ jsx(Text, { style: [baseStyle, { color }], children });
  }
  return /* @__PURE__ */ jsx(CloudscapeBox, { variant, fontWeight, color, children });
};

// src/DocumentExporter/layout/SpaceBetween.tsx
import * as React from "react";
import { View } from "@react-pdf/renderer";
import { jsx as jsx2 } from "react/jsx-runtime";
var SpaceBetween = ({ children, direction = "vertical", size = "m", id }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const gapMap2 = { xs: 4, s: 8, m: 16, l: 24 };
    return /* @__PURE__ */ jsx2(
      View,
      {
        id,
        style: {
          flexDirection: direction === "vertical" ? "column" : "row",
          gap: gapMap2[size]
        },
        children
      }
    );
  }
  const gapMap = { xs: "4px", s: "8px", m: "16px", l: "24px" };
  const marginProp = direction === "vertical" ? "marginBottom" : "marginRight";
  const childArray = React.Children.toArray(children);
  return /* @__PURE__ */ jsx2("div", { id, style: { display: "flex", flexDirection: direction === "vertical" ? "column" : "row" }, children: childArray.map((child, index) => /* @__PURE__ */ jsx2("div", { style: index < childArray.length - 1 ? { [marginProp]: gapMap[size] } : void 0, children: child }, index)) });
};

// src/DocumentExporter/layout/ColumnLayout.tsx
import * as React2 from "react";
import { View as View2 } from "@react-pdf/renderer";
import CloudscapeColumnLayout from "@cloudscape-design/components/column-layout";
import { jsx as jsx3 } from "react/jsx-runtime";
var ColumnLayout = ({ children, columns = 2 }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const childArray = React2.Children.toArray(children);
    const rows = [];
    for (let i = 0; i < childArray.length; i += columns) {
      rows.push(childArray.slice(i, i + columns));
    }
    return /* @__PURE__ */ jsx3(View2, { style: { gap: 12 }, children: rows.map((row, rowIndex) => /* @__PURE__ */ jsx3(View2, { style: { flexDirection: "row", gap: 16 }, children: row.map((child, colIndex) => /* @__PURE__ */ jsx3(View2, { style: { flex: 1 }, children: child }, colIndex)) }, rowIndex)) });
  }
  return /* @__PURE__ */ jsx3(CloudscapeColumnLayout, { columns, children });
};

// src/DocumentExporter/layout/Container.tsx
import { View as View3 } from "@react-pdf/renderer";
import { jsx as jsx4 } from "react/jsx-runtime";
var Container = ({ children, backgroundColor, id }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx4(
      View3,
      {
        id,
        style: {
          backgroundColor,
          padding: 16,
          borderRadius: 8
        },
        children
      }
    );
  }
  return /* @__PURE__ */ jsx4("div", { id, style: { backgroundColor, padding: "16px", borderRadius: "8px" }, children });
};

// src/DocumentExporter/content/Link.tsx
import { Text as Text2, Link as PDFLink } from "@react-pdf/renderer";
import CloudscapeLink from "@cloudscape-design/components/link";
import { jsx as jsx5 } from "react/jsx-runtime";
var Link = ({ children, href, external, size = "l" }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const fontSize = size === "s" ? 5 : size === "m" ? 9 : 12;
    const linkStyle = { ...pdfStyles.link, fontSize };
    if (href) {
      return /* @__PURE__ */ jsx5(PDFLink, { src: href, style: linkStyle, children });
    }
    return /* @__PURE__ */ jsx5(Text2, { style: linkStyle, children });
  }
  const fontSizeMap = { s: "body-s", m: "body-m", l: "body-m" };
  const handleClick = (event) => {
    if (href?.startsWith("#") && !external) {
      event.preventDefault();
      const elementId = href.substring(1);
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };
  return /* @__PURE__ */ jsx5(CloudscapeLink, { href, external, fontSize: fontSizeMap[size], onFollow: handleClick, children });
};

// src/DocumentExporter/content/List.tsx
import * as React3 from "react";
import { View as View4, Text as Text3 } from "@react-pdf/renderer";
import { jsx as jsx6, jsxs } from "react/jsx-runtime";
var List = ({ children, variant = "ul" }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const items = React3.Children.toArray(children);
    return /* @__PURE__ */ jsx6(View4, { style: { marginLeft: 20 }, children: items.map((item, index) => {
      const prefix = variant === "ol" ? `${index + 1}. ` : "\u2022 ";
      let content = "";
      if (typeof item === "string") {
        content = item;
      } else if (React3.isValidElement(item)) {
        content = item.props.children;
      }
      return /* @__PURE__ */ jsxs(View4, { style: { flexDirection: "row", marginBottom: 4 }, children: [
        /* @__PURE__ */ jsx6(Text3, { style: [pdfStyles.text, { marginRight: 8 }], children: prefix }),
        /* @__PURE__ */ jsx6(View4, { style: { flex: 1 }, children: typeof content === "string" || typeof content === "number" ? /* @__PURE__ */ jsx6(Text3, { style: pdfStyles.text, children: content }) : content })
      ] }, index);
    }) });
  }
  const ListTag = variant === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ jsx6(ListTag, { children });
};

// src/DocumentExporter/content/Image.tsx
import { Image as PDFImage } from "@react-pdf/renderer";
import { jsx as jsx7 } from "react/jsx-runtime";
var Image = ({ src, alt, style }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const pdfStyle = {};
    if (style?.width)
      pdfStyle.width = style.width;
    if (style?.height)
      pdfStyle.height = style.height;
    if (style?.objectFit)
      pdfStyle.objectFit = style.objectFit;
    if (style?.objectPosition)
      pdfStyle.objectPosition = style.objectPosition;
    return /* @__PURE__ */ jsx7(PDFImage, { src, style: pdfStyle });
  }
  return /* @__PURE__ */ jsx7("img", { src, alt, style });
};

// src/DocumentExporter/content/SectionHeader.tsx
import { Text as Text4 } from "@react-pdf/renderer";
import CloudscapeHeader from "@cloudscape-design/components/header";
import { jsx as jsx8 } from "react/jsx-runtime";
var SectionHeader = ({ children, variant = "h2", marginBottom, gradient = false, id }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const styleMap = { h1: pdfStyles.h1, h2: pdfStyles.h2, h3: pdfStyles.h3 };
    const defaultMargin2 = marginBottom !== void 0 ? typeof marginBottom === "number" ? marginBottom : parseFloat(marginBottom) : 20;
    return /* @__PURE__ */ jsx8(Text4, { id, style: [styleMap[variant], { marginBottom: defaultMargin2 }], children });
  }
  const defaultMargin = marginBottom !== void 0 ? typeof marginBottom === "string" ? marginBottom : `${marginBottom}px` : "40px";
  const gradientStyle = gradient ? {
    background: "linear-gradient(90deg, #7300e5 0%, #c74de0 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text"
  } : {};
  return /* @__PURE__ */ jsx8("div", { id, style: { marginBottom: defaultMargin }, children: /* @__PURE__ */ jsx8("div", { style: gradientStyle, children: /* @__PURE__ */ jsx8(CloudscapeHeader, { variant, children }) }) });
};

// src/DocumentExporter/content/StarRating.tsx
import { Svg, Path, View as View5 } from "@react-pdf/renderer";
import { jsx as jsx9, jsxs as jsxs2 } from "react/jsx-runtime";
var STAR_COLOR = "#FF9900";
var STAR_SIZE = 16;
var STAR_PATH = "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z";
var StarIcon = ({ fillPercentage }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const isFilled = fillPercentage > 50;
    return /* @__PURE__ */ jsx9(Svg, { width: STAR_SIZE, height: STAR_SIZE, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx9(Path, { d: STAR_PATH, fill: isFilled ? STAR_COLOR : "none", stroke: STAR_COLOR, strokeWidth: isFilled ? 0 : 1 }) });
  }
  const gradientId = `star-gradient-${fillPercentage}`;
  return /* @__PURE__ */ jsxs2("svg", { width: STAR_SIZE, height: STAR_SIZE, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx9("defs", { children: /* @__PURE__ */ jsxs2("linearGradient", { id: gradientId, children: [
      /* @__PURE__ */ jsx9("stop", { offset: `${fillPercentage}%`, stopColor: STAR_COLOR }),
      /* @__PURE__ */ jsx9("stop", { offset: `${fillPercentage}%`, stopColor: "transparent" })
    ] }) }),
    /* @__PURE__ */ jsx9("path", { d: STAR_PATH, fill: `url(#${gradientId})`, stroke: STAR_COLOR, strokeWidth: "1" })
  ] });
};
var StarRating = ({ rating }) => {
  const mode = useExportMode();
  const stars = Array.from({ length: 5 }, (_, index) => {
    const starValue = index + 1;
    if (rating >= starValue) {
      return 100;
    } else if (rating > index) {
      return (rating - index) * 100;
    } else {
      return 0;
    }
  });
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx9(View5, { style: { flexDirection: "row", gap: 2 }, children: stars.map((fillPercentage, index) => /* @__PURE__ */ jsx9(StarIcon, { fillPercentage }, index)) });
  }
  return /* @__PURE__ */ jsx9("div", { style: { display: "flex", flexDirection: "row", gap: "2px" }, children: stars.map((fillPercentage, index) => /* @__PURE__ */ jsx9(StarIcon, { fillPercentage }, index)) });
};

// src/DocumentExporter/content/EditableSection.tsx
import { SectionEditor } from "@amzn/awsmp-max-ux-patterns/SectionEditor";
import { Fragment, jsx as jsx10 } from "react/jsx-runtime";
var EditableSection = ({
  paths,
  refreshMessage,
  feedbackMessage,
  agent,
  shimmerVariant = "textBlock",
  children
}) => {
  const mode = useExportMode();
  if (mode !== "ui") {
    return /* @__PURE__ */ jsx10(Fragment, { children });
  }
  return /* @__PURE__ */ jsx10(
    SectionEditor,
    {
      onNewDataClearPathsFromUpdatingState: paths,
      refresh: { message: refreshMessage },
      edit: feedbackMessage ? { message: feedbackMessage } : void 0,
      agent,
      shimmerVariant,
      render: ({ renderOrShimmer }) => renderOrShimmer(children)
    }
  );
};

// src/DocumentExporter/document/Header.tsx
import * as React4 from "react";
import { View as View6, Text as Text5 } from "@react-pdf/renderer";
import Box2 from "@cloudscape-design/components/box";
import { jsx as jsx11, jsxs as jsxs3 } from "react/jsx-runtime";
var renderPDFContent = (content) => {
  if (React4.isValidElement(content)) {
    return content;
  }
  return /* @__PURE__ */ jsx11(Text5, { style: pdfStyles.text, children: content });
};
var Header = ({ left, right }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsxs3(
      View6,
      {
        style: {
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomWidth: 1,
          borderBottomColor: "#e0e0e0",
          paddingBottom: 12,
          marginBottom: 12
        },
        children: [
          left && renderPDFContent(left),
          right && renderPDFContent(right)
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx11(Box2, { children: /* @__PURE__ */ jsxs3(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        borderBottom: "1px solid #e0e0e0",
        paddingBottom: "12px",
        marginBottom: "12px"
      },
      children: [
        left && /* @__PURE__ */ jsx11("div", { children: left }),
        right && /* @__PURE__ */ jsx11("div", { children: right })
      ]
    }
  ) });
};

// src/DocumentExporter/document/Footer.tsx
import { View as View7, Text as Text6 } from "@react-pdf/renderer";
import Box3 from "@cloudscape-design/components/box";
import { jsx as jsx12, jsxs as jsxs4 } from "react/jsx-runtime";
var Footer = ({ left, right, disclaimer }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsxs4(
      View7,
      {
        style: {
          borderTopWidth: 1,
          borderTopColor: "#e0e0e0",
          paddingTop: 12,
          marginTop: 12
        },
        children: [
          /* @__PURE__ */ jsxs4(
            View7,
            {
              style: {
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: disclaimer ? 2 : 0
              },
              children: [
                left && /* @__PURE__ */ jsx12(Text6, { style: pdfStyles.text, children: left }),
                right && /* @__PURE__ */ jsx12(Text6, { style: pdfStyles.text, children: right })
              ]
            }
          ),
          disclaimer && /* @__PURE__ */ jsx12(View7, { children: disclaimer === "simple" ? /* @__PURE__ */ jsx12(
            Text6,
            {
              style: {
                ...pdfStyles.textS,
                color: "#5f6b7a"
              },
              children: "The information, recommendations, and content provided by this tool are generated by AI."
            }
          ) : /* @__PURE__ */ jsx12(
            Text6,
            {
              style: {
                ...pdfStyles.textS,
                color: "#5f6b7a"
              },
              children: "Sections are AI generated, so verify claims."
            }
          ) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx12(Box3, { children: /* @__PURE__ */ jsxs4(
    "div",
    {
      style: {
        borderTop: "1px solid #e0e0e0",
        paddingTop: "12px",
        marginTop: "12px"
      },
      children: [
        /* @__PURE__ */ jsxs4(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: disclaimer ? "2px" : "0"
            },
            children: [
              left && /* @__PURE__ */ jsx12("div", { children: left }),
              right && /* @__PURE__ */ jsx12("div", { children: right })
            ]
          }
        ),
        disclaimer && /* @__PURE__ */ jsx12(
          "div",
          {
            style: {
              fontSize: "0.875rem",
              color: "#5f6b7a"
            },
            children: disclaimer === "simple" ? /* @__PURE__ */ jsx12("span", { children: "The information, recommendations, and content provided by this tool are generated by AI." }) : /* @__PURE__ */ jsx12("span", { children: "Sections are AI generated, so verify claims." })
          }
        )
      ]
    }
  ) });
};

// src/DocumentExporter/document/Page.tsx
import { Page as PDFPage, View as View8 } from "@react-pdf/renderer";
import Box4 from "@cloudscape-design/components/box";
import { jsx as jsx13, jsxs as jsxs5 } from "react/jsx-runtime";
var Page = ({ children, variant = "standard", footer, size = "A4", orientation = "portrait" }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const padding2 = variant === "standard" ? 40 : 20;
    return /* @__PURE__ */ jsxs5(PDFPage, { size, orientation, style: { padding: padding2, fontFamily: "Open Sans" }, children: [
      /* @__PURE__ */ jsx13(View8, { style: { flex: 1 }, children }),
      footer && /* @__PURE__ */ jsx13(View8, { style: { position: "absolute", bottom: 20, left: padding2, right: padding2 }, children: footer })
    ] });
  }
  const dimensions = {
    A3: { width: 297, height: 420 },
    A4: { width: 210, height: 297 }
  };
  const { width, height } = dimensions[size];
  const isLandscape = orientation === "landscape";
  const aspectRatio = isLandscape ? `${height} / ${width}` : `${width} / ${height}`;
  const padding = variant === "standard" ? "40px" : "20px";
  return /* @__PURE__ */ jsx13(Box4, { children: /* @__PURE__ */ jsxs5(
    "div",
    {
      style: {
        maxWidth: `${isLandscape ? height : width}mm`,
        width: "100%",
        aspectRatio,
        padding,
        backgroundColor: "white",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column"
      },
      children: [
        /* @__PURE__ */ jsx13("div", { style: { flex: 1 }, children }),
        footer && /* @__PURE__ */ jsx13("div", { style: { marginTop: "auto", paddingTop: "20px" }, children: footer })
      ]
    }
  ) });
};

// src/DocumentExporter/content/NumberedList.tsx
import { View as View9, Text as Text7 } from "@react-pdf/renderer";
import { Fragment as Fragment2, jsx as jsx14, jsxs as jsxs6 } from "react/jsx-runtime";
var NumberedList = ({ items }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx14(Fragment2, { children: items.map((item, index) => /* @__PURE__ */ jsxs6(
      View9,
      {
        style: {
          flexDirection: "row",
          marginBottom: 12,
          alignItems: "flex-start"
        },
        children: [
          /* @__PURE__ */ jsx14(View9, { style: { width: "auto", marginRight: 16, minWidth: 40 }, children: /* @__PURE__ */ jsx14(Text7, { style: { ...pdfStyles.text, fontWeight: "bold", fontSize: 24 }, children: String(item.number) }) }),
          /* @__PURE__ */ jsx14(View9, { style: { flex: 1, paddingTop: 2 }, children: typeof item.content === "string" ? /* @__PURE__ */ jsx14(Text7, { style: pdfStyles.text, children: item.content }) : item.content })
        ]
      },
      index
    )) });
  }
  return /* @__PURE__ */ jsx14("div", { children: items.map((item, index) => /* @__PURE__ */ jsxs6(
    "div",
    {
      style: {
        display: "flex",
        marginBottom: "24px",
        alignItems: "flex-start"
      },
      children: [
        /* @__PURE__ */ jsx14(
          "div",
          {
            style: {
              width: "auto",
              marginRight: "16px",
              minWidth: "40px",
              fontWeight: "bold",
              fontSize: "24px",
              background: "linear-gradient(90deg, #7300e5 0%, #c74de0 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text"
            },
            children: String(item.number)
          }
        ),
        /* @__PURE__ */ jsx14("div", { style: { flex: 1, paddingTop: "2px" }, children: item.content })
      ]
    },
    index
  )) });
};

// src/DocumentExporter/document/Document.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
registerPDFFonts();
var PDFDocument = ({ render }) => {
  const mode = useExportMode();
  const components = {
    Box,
    SpaceBetween,
    Header: SectionHeader,
    ColumnLayout,
    Container,
    Link,
    List,
    Image,
    StarRating,
    EditableSection,
    DocumentHeader: Header,
    DocumentFooter: Footer,
    Page,
    NumberedList
  };
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx15(PDFDocumentContainer, { children: render(components) });
  }
  return /* @__PURE__ */ jsx15("div", { style: { display: "flex", flexDirection: "column", gap: "24px" }, children: render(components) });
};

// src/DocumentExporter/hooks/useDocumentSections.ts
import { useMemo, cloneElement, isValidElement as isValidElement3 } from "react";
function toKebabCase(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
function getDocumentSections(data, sectionsConfig) {
  const tocLinks = {};
  const sections = {};
  Object.entries(sectionsConfig).forEach(([sectionKey, config]) => {
    if (!config.shouldInclude(data)) {
      return;
    }
    const sectionId = toKebabCase(sectionKey);
    const anchorId = `#${sectionId}`;
    const linkElement = config.link({ href: anchorId });
    const sectionElement = config.section({ id: sectionId });
    if (isValidElement3(linkElement)) {
      tocLinks[sectionKey] = cloneElement(linkElement, { key: sectionKey });
    } else {
      tocLinks[sectionKey] = linkElement;
    }
    if (isValidElement3(sectionElement)) {
      sections[sectionKey] = cloneElement(sectionElement, { key: sectionKey });
    } else {
      sections[sectionKey] = sectionElement;
    }
  });
  return { tocLinks, sections };
}
function useDocumentSections(data, sectionsConfig) {
  return useMemo(() => getDocumentSections(data, sectionsConfig), [data, sectionsConfig]);
}

// src/DocumentExporter/content/AccoladeBadge.tsx
import { Svg as Svg2, Path as Path2, View as View10, Text as Text8 } from "@react-pdf/renderer";
import { jsx as jsx16, jsxs as jsxs7 } from "react/jsx-runtime";
var getAccoladeColorFromRank = (rank) => {
  if (rank <= 10) {
    return "#B2911C" /* GOLD */;
  } else if (rank <= 25) {
    return "#B4B4BB" /* SILVER */;
  } else if (rank <= 50) {
    return "#855900" /* BRONZE */;
  } else {
    return "#424650" /* STANDARD */;
  }
};
var getRankingNumberFromRank = (rank) => {
  if (rank <= 10) {
    return "10";
  } else if (rank <= 25) {
    return "25";
  } else if (rank <= 50) {
    return "50";
  } else {
    return "100";
  }
};
var LEFT_ACCOLADE_PATH = "M6.33771 7.24402C5.42581 6.79598 4.75924 5.90263 4.64608 4.82092C4.53879 3.7953 4.953 2.83225 5.67854 2.20034C6.59044 2.64838 7.25702 3.54173 7.37018 4.62344C7.47747 5.64905 7.06326 6.61211 6.33771 7.24402ZM2.65693 5.02901C2.71775 5.6104 2.87493 6.1584 3.11094 6.65879C2.31723 6.55355 1.4998 6.63604 0.731069 6.91344C-0.348347 8.69336 -0.250269 11.0325 1.14411 12.7343C1.53379 13.2099 1.99219 13.596 2.49318 13.8901C2.15223 14.0743 1.83137 14.2983 1.53839 14.56C1.22081 16.6202 2.21932 18.7615 4.1812 19.8259C4.79217 20.1573 5.43976 20.3535 6.08883 20.4246C5.43833 20.9184 4.91399 21.5506 4.57091 22.2777C5.18151 24.2887 7.11202 25.839 9.50208 26.0145C11.2348 26.1418 12.8341 25.5189 13.9249 24.4426C14.1073 24.9671 14.1879 25.5597 14.0751 26.1084C13.9799 26.5716 13.7462 27.0183 13.2881 27.4008C12.8209 27.791 12.0787 28.1482 10.9206 28.3412L11.1974 30.0019C12.5647 29.774 13.6113 29.3244 14.3673 28.693C15.1325 28.054 15.5564 27.2643 15.7243 26.4473C16.0495 24.8645 15.4099 23.2455 14.6568 22.325L14.6504 22.3302C13.8445 20.671 12.098 19.4534 9.9961 19.2991C9.96217 19.2966 9.9283 19.2944 9.89448 19.2924C9.9418 19.2532 9.98847 19.2131 10.0344 19.172C10.352 17.1118 9.35352 14.9705 7.39164 13.9062C7.28001 13.8456 7.16716 13.7896 7.05331 13.738C7.6831 12.335 7.65009 10.6867 6.90486 9.29098C8.55233 8.3167 9.57149 6.44352 9.35932 4.41535C9.12585 2.18358 7.47256 0.443977 5.39062 0C3.58051 0.920781 2.43302 2.88858 2.65693 5.02901ZM5.36086 12.569C5.65312 11.6223 5.47845 10.553 4.80583 9.73209C4.13383 8.91195 3.12098 8.53037 2.13611 8.6298C1.84384 9.57653 2.01851 10.6458 2.69113 11.4668C3.36313 12.2869 4.37598 12.6685 5.36086 12.569ZM6.43793 15.6642C7.40159 16.1869 7.97888 17.1246 8.07744 18.1097C7.19815 18.5634 6.09804 18.5904 5.1349 18.0679C4.17125 17.5451 3.59396 16.6075 3.49539 15.6224C4.37468 15.1686 5.4748 15.1417 6.43793 15.6642ZM6.83794 22.4436C7.38517 23.2765 8.38385 23.927 9.64855 24.0199C10.9139 24.1128 11.9973 23.6147 12.6602 22.87C12.113 22.0371 11.1143 21.3866 9.84962 21.2937C8.58429 21.2008 7.50089 21.6989 6.83794 22.4436Z";
var RIGHT_ACCOLADE_PATH = "M10.2846 7.24402C11.1965 6.79598 11.8631 5.90263 11.9762 4.82092C12.0835 3.7953 11.6693 2.83225 10.9438 2.20034C10.0319 2.64838 9.3653 3.54173 9.25214 4.62344C9.14485 5.64905 9.55906 6.61211 10.2846 7.24402ZM13.9654 5.02901C13.9046 5.6104 13.7474 6.1584 13.5114 6.65879C14.3051 6.55355 15.1225 6.63604 15.8912 6.91344C16.9707 8.69336 16.8726 11.0325 15.4782 12.7343C15.0885 13.2099 14.6301 13.596 14.1291 13.8901C14.4701 14.0743 14.7909 14.2983 15.0839 14.56C15.4015 16.6202 14.403 18.7615 12.4411 19.8259C11.8301 20.1573 11.1826 20.3535 10.5335 20.4246C11.184 20.9184 11.7083 21.5506 12.0514 22.2777C11.4408 24.2887 9.5103 25.839 7.12024 26.0145C5.38752 26.1418 3.78819 25.5189 2.69743 24.4426C2.51497 24.9671 2.43443 25.5597 2.54719 26.1084C2.64237 26.5716 2.87613 27.0183 3.33418 27.4008C3.80138 27.791 4.54364 28.1482 5.70172 28.3412L5.42494 30.0019C4.05761 29.774 3.01104 29.3244 2.255 28.693C1.48981 28.054 1.06592 27.2643 0.898041 26.4473C0.572813 24.8645 1.21237 23.2455 1.96551 22.325L1.97196 22.3302C2.77784 20.671 4.52432 19.4534 6.62621 19.2991C6.66014 19.2966 6.69402 19.2944 6.72784 19.2924C6.68051 19.2532 6.63385 19.2131 6.58787 19.172C6.27028 17.1118 7.26879 14.9705 9.23068 13.9062C9.3423 13.8456 9.45515 13.7896 9.56901 13.738C8.93922 12.335 8.97222 10.6867 9.71746 9.29098C8.06998 8.3167 7.05083 6.44352 7.26299 4.41535C7.49646 2.18358 9.14976 0.443977 11.2317 0C13.0418 0.920781 14.1893 2.88858 13.9654 5.02901ZM11.2615 12.569C10.9692 11.6223 11.1439 10.553 11.8165 9.73209C12.4885 8.91195 13.5013 8.53037 14.4862 8.6298C14.7785 9.57653 14.6038 10.6458 13.9312 11.4668C13.2592 12.2869 12.2463 12.6685 11.2615 12.569ZM10.1844 15.6642C9.22073 16.1869 8.64344 17.1246 8.54487 18.1097C9.42416 18.5634 10.5243 18.5904 11.4874 18.0679C12.4511 17.5451 13.0284 16.6075 13.1269 15.6224C12.2476 15.1686 11.1475 15.1417 10.1844 15.6642ZM9.78438 22.4436C9.23715 23.2765 8.23847 23.927 6.97376 24.0199C5.70843 24.1128 4.62503 23.6147 3.96208 22.87C4.50931 22.0371 5.50799 21.3866 6.77269 21.2937C8.03802 21.2008 9.12142 21.6989 9.78438 22.4436Z";
var LeftAccoladeIcon = ({ color }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx16(Svg2, { width: "16", height: "30", viewBox: "0 0 16 30", children: /* @__PURE__ */ jsx16(Path2, { d: LEFT_ACCOLADE_PATH, fill: color }) });
  }
  return /* @__PURE__ */ jsx16("svg", { width: "16", height: "30", viewBox: "0 0 16 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx16("path", { fillRule: "evenodd", clipRule: "evenodd", d: LEFT_ACCOLADE_PATH, fill: color }) });
};
var RightAccoladeIcon = ({ color }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx16(Svg2, { width: "17", height: "30", viewBox: "0 0 17 30", children: /* @__PURE__ */ jsx16(Path2, { d: RIGHT_ACCOLADE_PATH, fill: color }) });
  }
  return /* @__PURE__ */ jsx16("svg", { width: "17", height: "30", viewBox: "0 0 17 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx16("path", { fillRule: "evenodd", clipRule: "evenodd", d: RIGHT_ACCOLADE_PATH, fill: color }) });
};
var AccoladeBadge = ({ rank }) => {
  const mode = useExportMode();
  const badgeColor = getAccoladeColorFromRank(rank);
  const rankingNumber = getRankingNumberFromRank(rank);
  if (mode === "pdf") {
    return /* @__PURE__ */ jsxs7(View10, { style: { flexDirection: "row", alignItems: "center", gap: 4 }, children: [
      /* @__PURE__ */ jsx16(LeftAccoladeIcon, { color: badgeColor }),
      /* @__PURE__ */ jsxs7(View10, { style: { flexDirection: "column", alignItems: "center", justifyContent: "center" }, children: [
        /* @__PURE__ */ jsx16(Text8, { style: { fontSize: 7, lineHeight: 1 }, children: "Top" }),
        /* @__PURE__ */ jsx16(Text8, { style: { fontSize: 11, fontWeight: "bold", lineHeight: 1 }, children: rankingNumber })
      ] }),
      /* @__PURE__ */ jsx16(RightAccoladeIcon, { color: badgeColor })
    ] });
  }
  return /* @__PURE__ */ jsxs7("div", { style: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "4px" }, children: [
    /* @__PURE__ */ jsx16(LeftAccoladeIcon, { color: badgeColor }),
    /* @__PURE__ */ jsxs7("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "0px" }, children: [
      /* @__PURE__ */ jsx16("span", { style: { fontSize: "7px", lineHeight: "7px", display: "block" }, children: "Top" }),
      /* @__PURE__ */ jsx16("span", { style: { fontSize: "11px", fontWeight: "bold", lineHeight: "11px", display: "block" }, children: rankingNumber })
    ] }),
    /* @__PURE__ */ jsx16(RightAccoladeIcon, { color: badgeColor })
  ] });
};

// src/DocumentExporter/content/CitationBadge.tsx
import { Link as PDFLink2 } from "@react-pdf/renderer";

// src/Citations/CitationBadge.tsx
import * as React5 from "react";
import Link2 from "@cloudscape-design/components/link";
import Popover from "@cloudscape-design/components/popover";
import Box5 from "@cloudscape-design/components/box";
import SpaceBetween2 from "@cloudscape-design/components/space-between";
import Icon from "@cloudscape-design/components/icon";

// src/Citations/citation-utils.ts
function getCitationDomainLabel(url) {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.includes("amazon.com") ? "AWS" : "External";
  } catch {
    return "External";
  }
}
function getCitationIdLabel(id) {
  return `[${id}]`;
}

// src/Citations/useCitations.module.scss
var useCitations_module_default = {
  citationLink: "useCitations_module_citationLink2",
  citationNumber: "useCitations_module_citationNumber2",
  citationNumberCompact: "useCitations_module_citationNumberCompact2",
  citationNumberDefault: "useCitations_module_citationNumberDefault2",
  popoverLinkCompact: "useCitations_module_popoverLinkCompact2",
  popoverLinkDefault: "useCitations_module_popoverLinkDefault2",
  citationItem: "useCitations_module_citationItem2",
  citationHighlight: "useCitations_module_citationHighlight2",
  pulsate: "useCitations_module_pulsate2",
  popoverContent: "useCitations_module_popoverContent2",
  navigationSection: "useCitations_module_navigationSection2",
  divider: "useCitations_module_divider2",
  navigationButtons: "useCitations_module_navigationButtons2"
};

// src/Citations/CitationBadge.tsx
import { jsx as jsx17, jsxs as jsxs8 } from "react/jsx-runtime";
var CitationBadge = (props) => {
  const { citation, onBadgeClick, fontSize = "default" } = props;
  const handleClick = React5.useCallback(() => {
    onBadgeClick?.(citation);
  }, [citation, onBadgeClick]);
  const citationNumberClass = fontSize === "compact" ? useCitations_module_default.citationNumberCompact : useCitations_module_default.citationNumberDefault;
  const popoverLinkClass = fontSize === "compact" ? useCitations_module_default.popoverLinkCompact : useCitations_module_default.popoverLinkDefault;
  if (props.interactionMode === "popup") {
    const domainLabel2 = getCitationDomainLabel(citation.url);
    return /* @__PURE__ */ jsx17(
      Popover,
      {
        dismissButton: false,
        position: "top",
        size: "small",
        triggerType: "custom",
        content: /* @__PURE__ */ jsxs8(SpaceBetween2, { direction: "vertical", size: "xs", children: [
          /* @__PURE__ */ jsx17(Box5, { variant: "strong", children: citation.title }),
          citation.snippet && /* @__PURE__ */ jsx17(Box5, { variant: "p", children: citation.snippet }),
          /* @__PURE__ */ jsx17(Link2, { href: citation.url, external: true, className: popoverLinkClass, children: citation.url })
        ] }),
        children: /* @__PURE__ */ jsxs8(
          "button",
          {
            type: "button",
            className: useCitations_module_default.citationLink,
            "aria-label": `Citation from ${domainLabel2}, show details`,
            "aria-haspopup": "dialog",
            onClick: handleClick,
            children: [
              /* @__PURE__ */ jsx17(Icon, { name: "anchor-link", size: "small", "aria-hidden": "true" }),
              /* @__PURE__ */ jsx17("span", { className: citationNumberClass, children: domainLabel2 })
            ]
          }
        )
      }
    );
  }
  if (props.interactionMode === "scroll") {
    const handleScrollClick = (event) => {
      event.preventDefault();
      handleClick();
      const anchorId = `citation-${citation.id}`;
      const element = document.getElementById(anchorId);
      if (element) {
        props.scrollToElement(element, { behavior: "smooth" });
        element.setAttribute("tabindex", "-1");
        setTimeout(() => element.focus(), 500);
      }
    };
    const citationLabel = getCitationIdLabel(citation.id);
    return /* @__PURE__ */ jsxs8("button", { type: "button", className: useCitations_module_default.citationLink, "aria-label": `Go to citation ${citationLabel}`, onClick: handleScrollClick, children: [
      /* @__PURE__ */ jsx17(Icon, { name: "anchor-link", size: "small", "aria-hidden": "true" }),
      /* @__PURE__ */ jsx17("span", { className: citationNumberClass, children: citationLabel })
    ] });
  }
  const domainLabel = getCitationDomainLabel(citation.url);
  return /* @__PURE__ */ jsxs8(
    "a",
    {
      href: citation.url,
      className: useCitations_module_default.citationLink,
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": `Citation from ${domainLabel}, opens in new tab`,
      onClick: (_e) => {
        handleClick();
      },
      children: [
        /* @__PURE__ */ jsx17(Icon, { name: "anchor-link", size: "small", "aria-hidden": "true" }),
        /* @__PURE__ */ jsx17("span", { className: citationNumberClass, children: domainLabel })
      ]
    }
  );
};

// src/DocumentExporter/content/CitationBadge.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var CitationBadge2 = ({ citation, fontSize = "default", onBadgeClick, interactionMode, scrollToElement }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const pdfFontSize = fontSize === "compact" ? 9 : 12;
    const pdfInteractionMode = interactionMode || "scroll";
    if (pdfInteractionMode === "link") {
      return /* @__PURE__ */ jsx18(PDFLink2, { src: citation.url, style: { ...pdfStyles.link, fontSize: pdfFontSize, marginLeft: 2, marginRight: 2 }, children: getCitationIdLabel(citation.id) });
    } else {
      return /* @__PURE__ */ jsx18(PDFLink2, { src: `#citation-${citation.id}`, style: { ...pdfStyles.link, fontSize: pdfFontSize, marginLeft: 2, marginRight: 2 }, children: getCitationIdLabel(citation.id) });
    }
  }
  const uiMode = interactionMode || "link";
  if (uiMode === "scroll") {
    return /* @__PURE__ */ jsx18(
      CitationBadge,
      {
        citation,
        interactionMode: "scroll",
        scrollToElement: scrollToElement ?? ((el) => el.scrollIntoView({ behavior: "smooth" })),
        onBadgeClick,
        fontSize
      }
    );
  }
  return /* @__PURE__ */ jsx18(CitationBadge, { citation, interactionMode: "link", onBadgeClick, fontSize });
};

// src/DocumentExporter/content/SentimentBar.tsx
import { View as View11, Text as Text9 } from "@react-pdf/renderer";
import { jsx as jsx19, jsxs as jsxs9 } from "react/jsx-runtime";
var SentimentBar = ({ positive, negative, mixed, showLabels = false, height = 20 }) => {
  const mode = useExportMode();
  const colors = {
    positive: "#037F0C",
    // Green
    negative: "#D91515",
    // Red
    mixed: "#FF9900"
    // Orange
  };
  if (mode === "pdf") {
    return /* @__PURE__ */ jsxs9(View11, { children: [
      /* @__PURE__ */ jsxs9(
        View11,
        {
          style: {
            flexDirection: "row",
            width: "100%",
            height,
            borderRadius: 4,
            overflow: "hidden",
            borderWidth: 1,
            borderColor: "#CCCCCC",
            borderStyle: "solid"
          },
          children: [
            positive > 0 && /* @__PURE__ */ jsx19(
              View11,
              {
                style: {
                  width: `${positive}%`,
                  backgroundColor: colors.positive
                }
              }
            ),
            mixed > 0 && /* @__PURE__ */ jsx19(
              View11,
              {
                style: {
                  width: `${mixed}%`,
                  backgroundColor: colors.mixed
                }
              }
            ),
            negative > 0 && /* @__PURE__ */ jsx19(
              View11,
              {
                style: {
                  width: `${negative}%`,
                  backgroundColor: colors.negative
                }
              }
            )
          ]
        }
      ),
      showLabels && /* @__PURE__ */ jsxs9(
        View11,
        {
          style: {
            flexDirection: "row",
            marginTop: 4,
            gap: 12
          },
          children: [
            positive > 0 && /* @__PURE__ */ jsxs9(View11, { style: { flexDirection: "row", alignItems: "center", gap: 4 }, children: [
              /* @__PURE__ */ jsx19(
                View11,
                {
                  style: {
                    width: 8,
                    height: 8,
                    backgroundColor: colors.positive,
                    borderRadius: 2
                  }
                }
              ),
              /* @__PURE__ */ jsxs9(Text9, { style: [pdfStyles.text, { fontSize: 9 }], children: [
                "Positive: ",
                positive,
                "%"
              ] })
            ] }),
            mixed > 0 && /* @__PURE__ */ jsxs9(View11, { style: { flexDirection: "row", alignItems: "center", gap: 4 }, children: [
              /* @__PURE__ */ jsx19(
                View11,
                {
                  style: {
                    width: 8,
                    height: 8,
                    backgroundColor: colors.mixed,
                    borderRadius: 2
                  }
                }
              ),
              /* @__PURE__ */ jsxs9(Text9, { style: [pdfStyles.text, { fontSize: 9 }], children: [
                "Mixed: ",
                mixed,
                "%"
              ] })
            ] }),
            negative > 0 && /* @__PURE__ */ jsxs9(View11, { style: { flexDirection: "row", alignItems: "center", gap: 4 }, children: [
              /* @__PURE__ */ jsx19(
                View11,
                {
                  style: {
                    width: 8,
                    height: 8,
                    backgroundColor: colors.negative,
                    borderRadius: 2
                  }
                }
              ),
              /* @__PURE__ */ jsxs9(Text9, { style: [pdfStyles.text, { fontSize: 9 }], children: [
                "Negative: ",
                negative,
                "%"
              ] })
            ] })
          ]
        }
      )
    ] });
  }
  const segments = [];
  let offset = 0;
  if (positive > 0) {
    segments.push(`${colors.positive} ${offset}% ${offset + positive}%`);
    offset += positive;
  }
  if (mixed > 0) {
    segments.push(`${colors.mixed} ${offset}% ${offset + mixed}%`);
    offset += mixed;
  }
  if (negative > 0) {
    segments.push(`${colors.negative} ${offset}% ${offset + negative}%`);
  }
  return /* @__PURE__ */ jsxs9("div", { children: [
    /* @__PURE__ */ jsx19(
      "div",
      {
        style: {
          width: "100%",
          height: `${height}px`,
          background: `linear-gradient(to right, ${segments.join(", ")})`,
          borderRadius: "4px",
          border: "1px solid #CCCCCC"
        }
      }
    ),
    showLabels && /* @__PURE__ */ jsxs9(
      "div",
      {
        style: {
          display: "flex",
          gap: "12px",
          marginTop: "4px"
        },
        children: [
          positive > 0 && /* @__PURE__ */ jsxs9("div", { style: { display: "flex", alignItems: "center", gap: "4px" }, children: [
            /* @__PURE__ */ jsx19(
              "div",
              {
                style: {
                  width: "8px",
                  height: "8px",
                  backgroundColor: colors.positive,
                  borderRadius: "2px"
                }
              }
            ),
            /* @__PURE__ */ jsxs9("span", { style: { fontSize: "9px" }, children: [
              "Positive: ",
              positive,
              "%"
            ] })
          ] }),
          mixed > 0 && /* @__PURE__ */ jsxs9("div", { style: { display: "flex", alignItems: "center", gap: "4px" }, children: [
            /* @__PURE__ */ jsx19(
              "div",
              {
                style: {
                  width: "8px",
                  height: "8px",
                  backgroundColor: colors.mixed,
                  borderRadius: "2px"
                }
              }
            ),
            /* @__PURE__ */ jsxs9("span", { style: { fontSize: "9px" }, children: [
              "Mixed: ",
              mixed,
              "%"
            ] })
          ] }),
          negative > 0 && /* @__PURE__ */ jsxs9("div", { style: { display: "flex", alignItems: "center", gap: "4px" }, children: [
            /* @__PURE__ */ jsx19(
              "div",
              {
                style: {
                  width: "8px",
                  height: "8px",
                  backgroundColor: colors.negative,
                  borderRadius: "2px"
                }
              }
            ),
            /* @__PURE__ */ jsxs9("span", { style: { fontSize: "9px" }, children: [
              "Negative: ",
              negative,
              "%"
            ] })
          ] })
        ]
      }
    )
  ] });
};

// src/DocumentExporter/content/Icons.tsx
import { Svg as Svg3, Path as Path3 } from "@react-pdf/renderer";
import { jsx as jsx20 } from "react/jsx-runtime";
var CheckIcon = () => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx20(Svg3, { width: "16", height: "16", viewBox: "0 0 16 16", children: /* @__PURE__ */ jsx20(
      Path3,
      {
        d: "M13.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.793l6.646-6.647a.5.5 0 0 1 .708 0z",
        fill: "#037F0C"
      }
    ) });
  }
  return /* @__PURE__ */ jsx20("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx20(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.793l6.646-6.647a.5.5 0 0 1 .708 0z",
      fill: "#037F0C"
    }
  ) });
};
var PositiveSentimentIcon = () => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx20(Svg3, { width: "16", height: "18", viewBox: "0 0 16 18", children: /* @__PURE__ */ jsx20(
      Path3,
      {
        d: "M7.70711 4.28735L11.4142 7.99446L10 9.40867L8.70711 8.11578V15.7016H6.70711V8.11578L5.41421 9.40867L4 7.99446L7.70711 4.28735Z",
        fill: "#037F0C"
      }
    ) });
  }
  return /* @__PURE__ */ jsx20("svg", { width: "16", height: "18", viewBox: "0 0 16 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx20(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.70711 4.28735L11.4142 7.99446L10 9.40867L8.70711 8.11578V15.7016H6.70711V8.11578L5.41421 9.40867L4 7.99446L7.70711 4.28735Z",
      fill: "#037F0C"
    }
  ) });
};
var NegativeSentimentIcon = () => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx20(Svg3, { width: "16", height: "16", viewBox: "0 0 16 16", children: /* @__PURE__ */ jsx20(
      Path3,
      {
        d: "M6.70711 10.2473V2.6615H8.70711V10.2473L10 8.95439L11.4142 10.3686L7.70711 14.0757L4 10.3686L5.41421 8.95439L6.70711 10.2473Z",
        fill: "#DB0000"
      }
    ) });
  }
  return /* @__PURE__ */ jsx20("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx20(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.70711 10.2473V2.6615H8.70711V10.2473L10 8.95439L11.4142 10.3686L7.70711 14.0757L4 10.3686L5.41421 8.95439L6.70711 10.2473Z",
      fill: "#DB0000"
    }
  ) });
};
var MixedSentimentIcon = () => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx20(Svg3, { width: "16", height: "18", viewBox: "0 0 16 18", children: /* @__PURE__ */ jsx20(
      Path3,
      {
        d: "M11 4.28735L14.7072 7.99446L13.2929 9.40867L12 8.11578V15.7016H10V8.11578L8.70715 9.40867L7.29294 7.99446L11 4.28735ZM3.98006 12.2473V4.66149H5.98006V12.2473L7.27295 10.9544L8.68716 12.3686L4.98006 16.0757L1.27295 12.3686L2.68716 10.9544L3.98006 12.2473Z",
        fill: "#5F6B7A"
      }
    ) });
  }
  return /* @__PURE__ */ jsx20("svg", { width: "16", height: "18", viewBox: "0 0 16 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx20(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 4.28735L14.7072 7.99446L13.2929 9.40867L12 8.11578V15.7016H10V8.11578L8.70715 9.40867L7.29294 7.99446L11 4.28735ZM3.98006 12.2473V4.66149H5.98006V12.2473L7.27295 10.9544L8.68716 12.3686L4.98006 16.0757L1.27295 12.3686L2.68716 10.9544L3.98006 12.2473Z",
      fill: "#5F6B7A"
    }
  ) });
};

// src/DocumentExporter/content/Text.tsx
import { Text as PDFText } from "@react-pdf/renderer";
import { jsx as jsx21 } from "react/jsx-runtime";
var Text10 = ({ children, size = "l", weight = "normal" }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    const sizeStyle = size === "s" ? pdfStyles.textS : size === "m" ? pdfStyles.textM : pdfStyles.textL;
    const fontWeight = weight === "bold" ? 700 : 400;
    return /* @__PURE__ */ jsx21(PDFText, { style: [sizeStyle, { fontWeight }], children });
  }
  const fontSizeMap = { s: "10px", m: "13px", l: "14px" };
  const styles = {
    fontSize: fontSizeMap[size],
    fontWeight: weight === "bold" ? 700 : 400
  };
  return /* @__PURE__ */ jsx21("span", { style: styles, children });
};

// src/DocumentExporter/content/PDFButton.tsx
import { Link as PDFLink3, View as View12, Text as Text11 } from "@react-pdf/renderer";
import { jsx as jsx22 } from "react/jsx-runtime";
var PDFButton = ({ href, label, compact = false, backgroundColor = "#EC7211", textColor = "#000000" }) => {
  const buttonStyle = compact ? {
    backgroundColor,
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 12,
    alignSelf: "flex-start"
  } : {
    backgroundColor,
    paddingVertical: 6,
    paddingHorizontal: 20,
    borderRadius: 16,
    alignSelf: "flex-start"
  };
  const textStyle = compact ? {
    color: textColor,
    fontSize: 8,
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700
  } : {
    color: textColor,
    fontSize: 11,
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 700
  };
  return /* @__PURE__ */ jsx22(PDFLink3, { src: href, style: { textDecoration: "none" }, children: /* @__PURE__ */ jsx22(View12, { style: buttonStyle, children: /* @__PURE__ */ jsx22(Text11, { style: textStyle, children: label }) }) });
};

// src/DocumentExporter/content/BuyButton.tsx
import Button from "@amzn/awsui-components-react/polaris/button";
import { jsx as jsx23 } from "react/jsx-runtime";
var BuyButton = ({ href, label, compact = false }) => {
  const mode = useExportMode();
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx23(PDFButton, { href, label, compact });
  }
  return /* @__PURE__ */ jsx23(Button, { variant: "primary", href, target: "_blank", children: label });
};

// src/DocumentExporter/layout/DocumentTable.tsx
import { View as View13, Text as PDFText2 } from "@react-pdf/renderer";
import { jsx as jsx24, jsxs as jsxs10 } from "react/jsx-runtime";
var SingleTable = ({ columns, rows, mode, density = "high" }) => {
  const headerSize = density === "low" ? "l" : "m";
  if (mode === "pdf") {
    return /* @__PURE__ */ jsxs10(View13, { children: [
      /* @__PURE__ */ jsx24(
        View13,
        {
          style: {
            flexDirection: "row",
            borderBottomWidth: 2,
            borderBottomColor: "#000000",
            borderBottomStyle: "solid",
            paddingBottom: 4,
            marginBottom: 4
          },
          children: columns.map((column, index) => /* @__PURE__ */ jsx24(View13, { style: { width: column.width, paddingHorizontal: 4 }, children: /* @__PURE__ */ jsx24(Text10, { size: headerSize, weight: "bold", children: column.header }) }, index))
        }
      ),
      rows.map((row, rowIndex) => /* @__PURE__ */ jsx24(
        View13,
        {
          style: {
            flexDirection: "row",
            borderBottomWidth: rowIndex === rows.length - 1 ? 0 : 1,
            borderBottomColor: "#CCCCCC",
            borderBottomStyle: "solid",
            paddingVertical: 4,
            backgroundColor: row.backgroundColor
          },
          children: row.cells.map((cell, cellIndex) => {
            const align = row.align?.[cellIndex] || "left";
            const cellContent = typeof cell === "string" ? /* @__PURE__ */ jsx24(PDFText2, { style: pdfStyles.text, children: cell }) : cell;
            const alignedContent = align !== "left" ? /* @__PURE__ */ jsx24(
              View13,
              {
                style: {
                  flexDirection: "row",
                  justifyContent: align === "center" ? "center" : "flex-end",
                  width: "100%"
                },
                children: cellContent
              }
            ) : cellContent;
            return /* @__PURE__ */ jsx24(
              View13,
              {
                style: {
                  width: columns[cellIndex].width,
                  paddingHorizontal: 4,
                  flexWrap: "wrap",
                  flexShrink: 1
                },
                children: alignedContent
              },
              cellIndex
            );
          })
        },
        rowIndex
      ))
    ] });
  }
  const totalWidth = columns.reduce((sum, col) => sum + col.width, 0);
  return /* @__PURE__ */ jsxs10(
    "table",
    {
      style: {
        width: "100%",
        borderCollapse: "collapse",
        tableLayout: "fixed"
      },
      children: [
        /* @__PURE__ */ jsx24("thead", { children: /* @__PURE__ */ jsx24(
          "tr",
          {
            style: {
              borderBottom: "2px solid #000000"
            },
            children: columns.map((column, index) => /* @__PURE__ */ jsx24(
              "th",
              {
                style: {
                  width: `${column.width / totalWidth * 100}%`,
                  padding: "8px",
                  textAlign: "left"
                },
                children: /* @__PURE__ */ jsx24(Text10, { size: headerSize, weight: "bold", children: column.header })
              },
              index
            ))
          }
        ) }),
        /* @__PURE__ */ jsx24("tbody", { children: rows.map((row, rowIndex) => /* @__PURE__ */ jsx24(
          "tr",
          {
            style: {
              borderBottom: rowIndex === rows.length - 1 ? "none" : "1px solid #CCCCCC",
              backgroundColor: row.backgroundColor
            },
            children: row.cells.map((cell, cellIndex) => {
              const align = row.align?.[cellIndex] || "left";
              return /* @__PURE__ */ jsx24(
                "td",
                {
                  style: {
                    padding: "8px",
                    verticalAlign: "top",
                    textAlign: align
                  },
                  children: cell
                },
                cellIndex
              );
            })
          },
          rowIndex
        )) })
      ]
    }
  );
};
var DocumentTable = ({ columns, rows, maxProductsPerTable = 5, density = "high" }) => {
  const mode = useExportMode();
  const criteriaColumn = columns[0];
  const productColumns = columns.slice(1);
  if (productColumns.length <= maxProductsPerTable) {
    return /* @__PURE__ */ jsx24(SingleTable, { columns, rows, mode, density });
  }
  const productChunks = [];
  for (let i = 0; i < productColumns.length; i += maxProductsPerTable) {
    productChunks.push(productColumns.slice(i, i + maxProductsPerTable));
  }
  const tables = productChunks.map((productChunk, chunkIndex) => {
    const startIndex = chunkIndex * maxProductsPerTable;
    const tableColumns = [criteriaColumn, ...productChunk];
    const tableRows = rows.map((row) => ({
      ...row,
      cells: [
        row.cells[0],
        // Criteria cell
        ...row.cells.slice(1 + startIndex, 1 + startIndex + productChunk.length)
      ]
    }));
    return /* @__PURE__ */ jsx24(SingleTable, { columns: tableColumns, rows: tableRows, mode, density }, chunkIndex);
  });
  if (mode === "pdf") {
    return /* @__PURE__ */ jsx24(View13, { style: { gap: 16 }, children: tables });
  }
  return /* @__PURE__ */ jsx24("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: tables });
};

// src/DocumentExporter/index.ts
import { View as View14 } from "@react-pdf/renderer";

// src/DocumentExporter/exportAsPDF.ts
import { pdf } from "@react-pdf/renderer";
import { createElement } from "react";
async function downloadDocumentAsPDF(component, filename = "document.pdf") {
  const pdfComponent = createElement(ModeProvider, { value: "pdf" }, component);
  const blob = await pdf(pdfComponent).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

// src/DocumentExporter/exportAsCSV.ts
var import_papaparse = __toESM(require_papaparse_min(), 1);
async function downloadDocumentAsCSV(data, filename = "document.csv") {
  const csv = import_papaparse.default.unparse({
    fields: data.headers,
    data: data.rows
  });
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
export {
  AccoladeBadge,
  BuyButton,
  CheckIcon,
  CitationBadge2 as CitationBadge,
  DocumentTable,
  EditableSection,
  Link,
  MixedSentimentIcon,
  ModeProvider,
  NegativeSentimentIcon,
  PDFButton,
  PDFDocument,
  PDF_FONT_FAMILY,
  PositiveSentimentIcon,
  SentimentBar,
  StarRating,
  Text10 as Text,
  View14 as View,
  downloadDocumentAsCSV as exportAsCSV,
  downloadDocumentAsPDF as exportAsPDF,
  getDocumentSections,
  initializePDFPolyfills,
  pdfStyles,
  useDocumentSections,
  useExportMode
};
/*! Bundled license information:

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

papaparse/papaparse.min.js:
  (* @license
  Papa Parse
  v5.5.3
  https://github.com/mholt/PapaParse
  License: MIT
  *)
*/
//# sourceMappingURL=index.js.map
